/* tslint:disable */
/* eslint-disable */
/**
 * orderManage API
 * 発注情報に対する情報を操作するAPI群
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BulkDeleteOrderInfosInner
 */
export interface BulkDeleteOrderInfosInner {
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteOrderInfosInner
     */
    'orderId': string;
}
/**
 * 
 * @export
 * @interface BulkDeleteOrderRequest
 */
export interface BulkDeleteOrderRequest {
    /**
     * 発注情報削除(bulk)で渡す発注情報の型
     * @type {Array<BulkDeleteOrderInfosInner>}
     * @memberof BulkDeleteOrderRequest
     */
    'bulkDeleteOrderInfos': Array<BulkDeleteOrderInfosInner>;
}
/**
 * 
 * @export
 * @interface BulkPostOrderRequest
 */
export interface BulkPostOrderRequest {
    /**
     * 発注情報登録(bulk)で渡す発注情報の型
     * @type {Array<PostOrderRequestInfo>}
     * @memberof BulkPostOrderRequest
     */
    'bulkPostOrderInfo': Array<PostOrderRequestInfo>;
    /**
     * 
     * @type {Array<BulkPostOrderRequestOrderBasisAdjustmentsInner>}
     * @memberof BulkPostOrderRequest
     */
    'orderBasisAdjustments': Array<BulkPostOrderRequestOrderBasisAdjustmentsInner>;
}
/**
 * 
 * @export
 * @interface BulkPostOrderRequestOrderBasisAdjustmentsInner
 */
export interface BulkPostOrderRequestOrderBasisAdjustmentsInner {
    /**
     * 
     * @type {string}
     * @memberof BulkPostOrderRequestOrderBasisAdjustmentsInner
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {OrderBasisAdjustedInfo}
     * @memberof BulkPostOrderRequestOrderBasisAdjustmentsInner
     */
    'adjustment': OrderBasisAdjustedInfo;
}
/**
 * bulk-postした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface BulkPostOrderResponse
 */
export interface BulkPostOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkPostOrderResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BulkPostOrderResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BulkPostOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {BulkPostOrderResponseInfo}
     * @memberof BulkPostOrderResponse
     */
    'result': BulkPostOrderResponseInfo;
}
/**
 * 発注登録API(bulk)のレスポンスの型定義
 * @export
 * @interface BulkPostOrderResponseInfo
 */
export interface BulkPostOrderResponseInfo {
    /**
     * 表示用ID(リクエストに含まれていた場合), 登録された発注IDのペアの配列
     * @type {Array<BulkPostOrderResponseInfoRegisteredOrderIdsInner>}
     * @memberof BulkPostOrderResponseInfo
     */
    'registeredOrderIds': Array<BulkPostOrderResponseInfoRegisteredOrderIdsInner>;
}
/**
 * 
 * @export
 * @interface BulkPostOrderResponseInfoRegisteredOrderIdsInner
 */
export interface BulkPostOrderResponseInfoRegisteredOrderIdsInner {
    /**
     * ローカルの表示用ID (登録完了したときのorderIDと紐づけるために使う。シミュレーション画面でしか現状使っていない。それ以外の画面ではnullを送る)
     * @type {string}
     * @memberof BulkPostOrderResponseInfoRegisteredOrderIdsInner
     */
    'displayId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPostOrderResponseInfoRegisteredOrderIdsInner
     */
    'orderId': string;
}
/**
 * 
 * @export
 * @interface BulkPutOrderRequest
 */
export interface BulkPutOrderRequest {
    /**
     * 編集項目の配列
     * @type {Array<EditableProperties>}
     * @memberof BulkPutOrderRequest
     */
    'bulkPutOrderInfo': Array<EditableProperties>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkPutOrderRequest
     */
    'abortOnInvalid'?: boolean;
}
/**
 * 発注をbulk-putした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface BulkPutOrderResponse
 */
export interface BulkPutOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkPutOrderResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BulkPutOrderResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BulkPutOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {BulkPutOrderResponseResult}
     * @memberof BulkPutOrderResponse
     */
    'result': BulkPutOrderResponseResult;
}
/**
 * APIから受け取る成功/失敗した発注IDの一覧
 * @export
 * @interface BulkPutOrderResponseResult
 */
export interface BulkPutOrderResponseResult {
    /**
     * 編集に成功した発注IDの一覧
     * @type {Array<string>}
     * @memberof BulkPutOrderResponseResult
     */
    'updatedOrderId': Array<string>;
    /**
     * 編集に失敗した発注IDの一覧
     * @type {Array<string>}
     * @memberof BulkPutOrderResponseResult
     */
    'notUpdatedOrderId': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkRegisterOrderBusinessRequest
 */
export interface BulkRegisterOrderBusinessRequest {
    /**
     * 登録する発注取引の情報の配列
     * @type {Array<RegisterOrderBusinessInfo>}
     * @memberof BulkRegisterOrderBusinessRequest
     */
    'bulkRegisterOrderBusinessInfo': Array<RegisterOrderBusinessInfo>;
}
/**
 * 発注取引をbulkで登録した時のレスポンス
 * @export
 * @interface BulkRegisterOrderBusinessResponse
 */
export interface BulkRegisterOrderBusinessResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BulkRegisterOrderBusinessResponse
     */
    'message': string;
    /**
     * 
     * @type {BulkRegisterOrderBusinessResponseResult}
     * @memberof BulkRegisterOrderBusinessResponse
     */
    'result': BulkRegisterOrderBusinessResponseResult;
}
/**
 * 
 * @export
 * @interface BulkRegisterOrderBusinessResponseResult
 */
export interface BulkRegisterOrderBusinessResponseResult {
    /**
     * 
     * @type {BulkRegisterOrderBusinessResponseResultRegisteredOrderCount}
     * @memberof BulkRegisterOrderBusinessResponseResult
     */
    'registeredOrderCount': BulkRegisterOrderBusinessResponseResultRegisteredOrderCount;
    /**
     * 
     * @type {BulkRegisterOrderBusinessResponseResultAlertedOrderCount}
     * @memberof BulkRegisterOrderBusinessResponseResult
     */
    'alertedOrderCount': BulkRegisterOrderBusinessResponseResultAlertedOrderCount;
}
/**
 * 登録された発注数
 * @export
 * @interface BulkRegisterOrderBusinessResponseResultAlertedOrderCount
 */
export interface BulkRegisterOrderBusinessResponseResultAlertedOrderCount {
    /**
     * 発注番号が空欄の発注数
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponseResultAlertedOrderCount
     */
    'orderWithoutNumber': number;
    /**
     * 在庫切れの可能性がある発注数
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponseResultAlertedOrderCount
     */
    'outOfStockOrder': number;
    /**
     * 納期を過ぎている発注数
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponseResultAlertedOrderCount
     */
    'overdueOrder': number;
}
/**
 * 登録された発注数
 * @export
 * @interface BulkRegisterOrderBusinessResponseResultRegisteredOrderCount
 */
export interface BulkRegisterOrderBusinessResponseResultRegisteredOrderCount {
    /**
     * 更新された発注数
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponseResultRegisteredOrderCount
     */
    'updated': number;
    /**
     * 発注管理番号を使用して発注番号を登録した発注数
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponseResultRegisteredOrderCount
     */
    'linkedOrderNumberByIssued': number;
    /**
     * 納期と数量を使用して発注番号を登録した発注数
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponseResultRegisteredOrderCount
     */
    'linkedOrderNumberByEtaAmount': number;
    /**
     * 未照合に登録された発注数
     * @type {number}
     * @memberof BulkRegisterOrderBusinessResponseResultRegisteredOrderCount
     */
    'unmatched': number;
}
/**
 * 発注納期一括変更のリクエスト
 * @export
 * @interface BulkUpdateOrderEtaInfo
 */
export interface BulkUpdateOrderEtaInfo {
    /**
     * 
     * @type {Array<BulkUpdateOrderEtaInfoOrderInfosInner>}
     * @memberof BulkUpdateOrderEtaInfo
     */
    'orderInfos': Array<BulkUpdateOrderEtaInfoOrderInfosInner>;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateOrderEtaInfo
     */
    'estimatedTimeOfArrival': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateOrderEtaInfo
     */
    'applyToGroup'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkUpdateOrderEtaInfoOrderInfosInner
 */
export interface BulkUpdateOrderEtaInfoOrderInfosInner {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateOrderEtaInfoOrderInfosInner
     */
    'orderId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateOrderEtaInfoOrderInfosInner
     */
    'updateAt': number;
}
/**
 * 
 * @export
 * @interface BulkUpdateOrderEtaRequest
 */
export interface BulkUpdateOrderEtaRequest {
    /**
     * 
     * @type {BulkUpdateOrderEtaInfo}
     * @memberof BulkUpdateOrderEtaRequest
     */
    'updateEtaInfo': BulkUpdateOrderEtaInfo;
}
/**
 * 取引自由欄値
 * @export
 * @interface BusinessFreeColumnValue
 */
export interface BusinessFreeColumnValue {
    /**
     * 
     * @type {number}
     * @memberof BusinessFreeColumnValue
     */
    'columnNo': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'headerName': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'value': string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessFreeColumnValue
     */
    'isMulti': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessFreeColumnValue
     */
    'isConfigured': boolean;
    /**
     * 自由欄の対象（集計取引/関連取引）。columnNo は対象ごとに 1 から採番されるため、未管理登録などで対象を判別する必要がある場合に指定する。
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'target'?: BusinessFreeColumnValueTargetEnum;
}

export const BusinessFreeColumnValueTargetEnum = {
    Aggregate: 'aggregate',
    Base: 'base'
} as const;

export type BusinessFreeColumnValueTargetEnum = typeof BusinessFreeColumnValueTargetEnum[keyof typeof BusinessFreeColumnValueTargetEnum];

/**
 * 発注の更新項目と値。任意項目を省略した場合は現在値を維持し、 nullableな項目へnullを指定した場合は登録値をクリアする。
 * @export
 * @interface EditableProperties
 */
export interface EditableProperties {
    /**
     * 
     * @type {string}
     * @memberof EditableProperties
     */
    'orderId': string;
    /**
     * 発注番号。nullまたは空文字を指定すると登録値をクリアする
     * @type {string}
     * @memberof EditableProperties
     */
    'orderNumber'?: string | null;
    /**
     * 納入日。指定する場合はnull不可
     * @type {string}
     * @memberof EditableProperties
     */
    'orderEstimateTimeOfArrival'?: string;
    /**
     * 港納期(Port ETA)。指定する場合はnull不可
     * @type {string}
     * @memberof EditableProperties
     */
    'orderPortEta'?: string;
    /**
     * 発注数量。指定する場合はnull不可
     * @type {string}
     * @memberof EditableProperties
     */
    'orderAmount'?: string;
    /**
     * 発注ステータス。指定する場合はnull不可
     * @type {string}
     * @memberof EditableProperties
     */
    'orderStatus'?: string;
    /**
     * 発注メモ。nullまたは空文字を指定すると登録値をクリアする
     * @type {string}
     * @memberof EditableProperties
     */
    'orderNote'?: string | null;
    /**
     * 取得時の最終更新時間。CONFLICTの検証に使用される
     * @type {number}
     * @memberof EditableProperties
     */
    'updateAt': number;
    /**
     * リマインドメールデータID。nullまたは空文字を指定すると登録値をクリアする
     * @type {string}
     * @memberof EditableProperties
     */
    'reminderMailDataId'?: string | null;
    /**
     * 更新後の分納情報一覧。省略した場合は既存の分納情報を維持し、 空配列を指定した場合は既存の分納情報をすべて削除する。
     * @type {Array<PartialDeliveryRequest>}
     * @memberof EditableProperties
     */
    'partialDeliveryList'?: Array<PartialDeliveryRequest>;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * getした時にレスポンスで受け取る情報の型定義 (発注管理ページ 展開)
 * @export
 * @interface GetOrderBusinessBelongResponse
 */
export interface GetOrderBusinessBelongResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderBusinessBelongResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderBusinessBelongResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderBusinessBelongResponse
     */
    'message': string;
    /**
     * 
     * @type {GetOrderBusinessBelongResponseResult}
     * @memberof GetOrderBusinessBelongResponse
     */
    'result': GetOrderBusinessBelongResponseResult;
}
/**
 * APIから受け取るレスポンスの型 (発注管理ページ)
 * @export
 * @interface GetOrderBusinessBelongResponseResult
 */
export interface GetOrderBusinessBelongResponseResult {
    /**
     * 
     * @type {GetOrderBusinessBelongResponseResultData}
     * @memberof GetOrderBusinessBelongResponseResult
     */
    'data': GetOrderBusinessBelongResponseResultData;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetOrderBusinessBelongResponseResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * APIから受け取る発注情報 (子取引情報)
 * @export
 * @interface GetOrderBusinessBelongResponseResultData
 */
export interface GetOrderBusinessBelongResponseResultData {
    /**
     * 組織ID
     * @type {string}
     * @memberof GetOrderBusinessBelongResponseResultData
     */
    'organizationId'?: string;
    /**
     * 取引ID
     * @type {string}
     * @memberof GetOrderBusinessBelongResponseResultData
     */
    'businessId'?: string;
    /**
     * 集計ID
     * @type {string}
     * @memberof GetOrderBusinessBelongResponseResultData
     */
    'aggregateBusinessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderBusinessBelongResponseResultData
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof GetOrderBusinessBelongResponseResultData
     */
    'customerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderBusinessBelongResponseResultData
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof GetOrderBusinessBelongResponseResultData
     */
    'salesDestinationName'?: string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof GetOrderBusinessBelongResponseResultData
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
}
/**
 * getした時にレスポンスで受け取る情報の型定義 (発注管理ページ)
 * @export
 * @interface GetOrderBusinessResponse
 */
export interface GetOrderBusinessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderBusinessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderBusinessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderBusinessResponse
     */
    'message': string;
    /**
     * 
     * @type {GetOrderBusinessResponseResult}
     * @memberof GetOrderBusinessResponse
     */
    'result': GetOrderBusinessResponseResult;
}
/**
 * APIから受け取るレスポンスの型 (発注管理ページ)
 * @export
 * @interface GetOrderBusinessResponseResult
 */
export interface GetOrderBusinessResponseResult {
    /**
     * APIから受け取る発注情報一覧の型 (発注管理ページ)
     * @type {Array<GetOrderBusinessResponseResultDataInner>}
     * @memberof GetOrderBusinessResponseResult
     */
    'data': Array<GetOrderBusinessResponseResultDataInner>;
    /**
     * 
     * @type {GetOrderBusinessResponseResultSummaryCount}
     * @memberof GetOrderBusinessResponseResult
     */
    'summaryCount': GetOrderBusinessResponseResultSummaryCount;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetOrderBusinessResponseResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * 
 * @export
 * @interface GetOrderBusinessResponseResultDataInner
 */
export interface GetOrderBusinessResponseResultDataInner {
    /**
     * 発注ID
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'orderId': string;
    /**
     * 集計ID
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'aggregateBusinessId': string;
    /**
     * 発注ステータス
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'orderStatus': string;
    /**
     * 発注日（発注推奨に関しては存在しないので-1で返しています）
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'createdOrderDate'?: number;
    /**
     * 希望納期
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'desiredDeliveryDate': number;
    /**
     * 発注数量
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'orderAmount': number;
    /**
     * 置場CD
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'warehouse': string;
    /**
     * 仕入先CD
     * @type {any}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'supplierNumber': any;
    /**
     * 仕入先名
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'supplierName': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'businessName': string;
    /**
     * 容量
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'package': number;
    /**
     * 単位
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'unit': string;
    /**
     * 製造社
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'manufacturer'?: string;
    /**
     * 標準在庫指数（MIN）
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'standardInventoryIndexMin': number;
    /**
     * 標準在庫指数（MAX）
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'standardInventoryIndexMax': number;
    /**
     * 標準在庫指数（単位）
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'standardInventoryIndexUnit': string;
    /**
     * 最終チェック日時（ms）
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'lastCheckedAt'?: number;
    /**
     * リードタイム
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'leadTime': number;
    /**
     * リードタイム単位
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'leadTimeUnit': string;
    /**
     * 仕入単価
     * @type {string}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'purchaseUnitPrice'?: string | null;
    /**
     * key,value形式のユーザー任意項目(24/8/23 現状、顧客台帳ID用を想定)
     * @type {{ [key: string]: string; }}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'userCustomParameters': { [key: string]: string; };
    /**
     * 集計取引の自由欄値
     * @type {Array<BusinessFreeColumnValue>}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValue>;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'aggregateBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'createAt': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderBusinessResponseResultDataInner
     */
    'updateAt': number;
}
/**
 * APIから受け取る発注ステータスごとの件数 (発注管理ページ)
 * @export
 * @interface GetOrderBusinessResponseResultSummaryCount
 */
export interface GetOrderBusinessResponseResultSummaryCount {
    /**
     * 推奨
     * @type {number}
     * @memberof GetOrderBusinessResponseResultSummaryCount
     */
    'Recommended': number;
    /**
     * 承認依頼
     * @type {number}
     * @memberof GetOrderBusinessResponseResultSummaryCount
     */
    'ApprovalRequested': number;
    /**
     * 承認済
     * @type {number}
     * @memberof GetOrderBusinessResponseResultSummaryCount
     */
    'ApprovedAwaitingDeliveryDate': number;
}
/**
 * getした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface GetOrderResponse
 */
export interface GetOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {GetOrderResponseResult}
     * @memberof GetOrderResponse
     */
    'result': GetOrderResponseResult;
}
/**
 * APIから受け取るレスポンスの型
 * @export
 * @interface GetOrderResponseResult
 */
export interface GetOrderResponseResult {
    /**
     * APIから受け取る発注情報一覧の型
     * @type {Array<GetOrderResponseResultDataInner>}
     * @memberof GetOrderResponseResult
     */
    'data': Array<GetOrderResponseResultDataInner>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetOrderResponseResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * 
 * @export
 * @interface GetOrderResponseResultDataInner
 */
export interface GetOrderResponseResultDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'supplierNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'businessNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'businessName': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'package': number;
    /**
     * key,value形式のユーザー任意項目(24/8/23 現状、顧客台帳ID用を想定)
     * @type {{ [key: string]: string; }}
     * @memberof GetOrderResponseResultDataInner
     */
    'userCustomParameters': { [key: string]: string; };
    /**
     * 集計取引の自由欄値
     * @type {Array<BusinessFreeColumnValue>}
     * @memberof GetOrderResponseResultDataInner
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValue>;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'unit': string;
    /**
     * 製造社
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'warehouseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'warehouse': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'orderIssuedNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'orderNumber': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'createdOrderDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'desiredDeliveryDate': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'estimatedTimeOfArrival': number;
    /**
     * 港納期(Port ETA)
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'portEta'?: number | null;
    /**
     * 国内輸送日数。0は未設定として扱う
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'inTransitDays': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'orderAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'orderStatus': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'outputDate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderResponseResultDataInner
     */
    'isOutOfStockExpected': boolean;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof GetOrderResponseResultDataInner
     */
    'aggregateBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'orderNote'?: string;
    /**
     * 
     * @type {Array<OrderGroupResponse>}
     * @memberof GetOrderResponseResultDataInner
     */
    'orderGroupList': Array<OrderGroupResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'createAt': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'updateAt': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponseResultDataInner
     */
    'statusUpdateAt'?: number;
    /**
     * 分納情報（分納ステータスではない時は空の配列）
     * @type {Array<PartialDeliveryResponse>}
     * @memberof GetOrderResponseResultDataInner
     */
    'partialDeliveryList': Array<PartialDeliveryResponse>;
    /**
     * 
     * @type {UserData}
     * @memberof GetOrderResponseResultDataInner
     */
    'lastUpdatedByUser': UserData;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'reminderMailDataId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'orderBasisId'?: string;
    /**
     * 仕入単価
     * @type {string}
     * @memberof GetOrderResponseResultDataInner
     */
    'purchaseUnitPrice'?: string | null;
}
/**
 * 発注テンプレート一覧取得レスポンス
 * @export
 * @interface GetOrderTemplateListResponse
 */
export interface GetOrderTemplateListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderTemplateListResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderTemplateListResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderTemplateListResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderTemplateListResult}
     * @memberof GetOrderTemplateListResponse
     */
    'result': OrderTemplateListResult;
}
/**
 * 発注テンプレート詳細取得レスポンス
 * @export
 * @interface GetOrderTemplateResponse
 */
export interface GetOrderTemplateResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderTemplateResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderTemplateResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderTemplateResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderTemplateDetailResult}
     * @memberof GetOrderTemplateResponse
     */
    'result': OrderTemplateDetailResult;
}
/**
 * objectで渡すフィルターの情報
 * @export
 * @interface ObjectFilterInfo
 */
export interface ObjectFilterInfo {
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮したリードタイム情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'leadTimeInfoList'?: string;
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮した標準在庫指数(min)情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'stdInventoryIndexMinInfoList'?: string;
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮した標準在庫指数(max)情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'stdInventoryIndexMaxInfoList'?: string;
}
/**
 * 発注数量一覧取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface OrderAmountResponse
 */
export interface OrderAmountResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderAmountResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderAmountResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderAmountResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderAmountResponseAllOfResult}
     * @memberof OrderAmountResponse
     */
    'result': OrderAmountResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface OrderAmountResponseAllOfResult
 */
export interface OrderAmountResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderAmountResponseAllOfResult
     */
    'orderAmounts': Array<string>;
}
/**
 * 発注確定時にユーザーが操作した内示値
 * @export
 * @interface OrderBasisAdjustedCustomerForecast
 */
export interface OrderBasisAdjustedCustomerForecast {
    /**
     * 対象年
     * @type {number}
     * @memberof OrderBasisAdjustedCustomerForecast
     */
    'targetYear': number;
    /**
     * 対象月
     * @type {number}
     * @memberof OrderBasisAdjustedCustomerForecast
     */
    'targetMonth': number;
    /**
     * 発注確定時にユーザーが操作した客先内示の値
     * @type {string}
     * @memberof OrderBasisAdjustedCustomerForecast
     */
    'amount': string;
}
/**
 * 発注情報登録で渡す発注根拠情報の型定義
 * @export
 * @interface OrderBasisAdjustedInfo
 */
export interface OrderBasisAdjustedInfo {
    /**
     * 発注確定時にユーザーが操作したリードタイム（userAdjustedLeadTimeUnitに対応する値）
     * @type {number}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedLeadTime'?: number;
    /**
     * 発注確定時にユーザーが操作したリードタイム単位
     * @type {string}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedLeadTimeUnit'?: OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum;
    /**
     * 発注確定時にユーザーが操作した標準在庫指数最小値(単位に合わせた数値)
     * @type {number}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedStdInventoryIndexMin'?: number;
    /**
     * 発注確定時にユーザーが操作した標準在庫指数最大値(単位に合わせた数値)
     * @type {number}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedStdInventoryIndexMax'?: number;
    /**
     * 発注確定時にユーザーが操作した標準在庫指数単位
     * @type {string}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedStdInventoryIndexUnit'?: OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum;
    /**
     * 
     * @type {Array<OrderBasisAdjustedCustomerForecast>}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedCustomerForecasts'?: Array<OrderBasisAdjustedCustomerForecast>;
}

export const OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum = typeof OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum[keyof typeof OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum];
export const OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum = typeof OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum[keyof typeof OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum];

/**
 * 発注日一覧取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface OrderDateResponse
 */
export interface OrderDateResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderDateResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderDateResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderDateResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderDateResponseAllOfResult}
     * @memberof OrderDateResponse
     */
    'result': OrderDateResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface OrderDateResponseAllOfResult
 */
export interface OrderDateResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDateResponseAllOfResult
     */
    'orderDates': Array<string>;
}
/**
 * 納期一覧取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface OrderDeliveryDateResponse
 */
export interface OrderDeliveryDateResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderDeliveryDateResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderDeliveryDateResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryDateResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderDeliveryDateResponseAllOfResult}
     * @memberof OrderDeliveryDateResponse
     */
    'result': OrderDeliveryDateResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface OrderDeliveryDateResponseAllOfResult
 */
export interface OrderDeliveryDateResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDeliveryDateResponseAllOfResult
     */
    'orderDeliveryDates': Array<string>;
}
/**
 * 希望納期一覧取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface OrderDesiredDeliveryDateResponse
 */
export interface OrderDesiredDeliveryDateResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderDesiredDeliveryDateResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderDesiredDeliveryDateResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderDesiredDeliveryDateResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderDesiredDeliveryDateResponseAllOfResult}
     * @memberof OrderDesiredDeliveryDateResponse
     */
    'result': OrderDesiredDeliveryDateResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface OrderDesiredDeliveryDateResponseAllOfResult
 */
export interface OrderDesiredDeliveryDateResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDesiredDeliveryDateResponseAllOfResult
     */
    'orderDesiredDeliveryDates': Array<string>;
}
/**
 * 発注グループを表すスキーマ
 * @export
 * @interface OrderGroupResponse
 */
export interface OrderGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderGroupResponse
     */
    'orderGroupId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderGroupResponse
     */
    'orderGroupName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderGroupResponse
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderGroupResponse
     */
    'destinationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderGroupResponse
     */
    'upperLimitQuantity': number;
}
/**
 * 発注ID一覧取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface OrderIdsResponse
 */
export interface OrderIdsResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderIdsResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderIdsResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderIdsResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderIdsResponseAllOfResult}
     * @memberof OrderIdsResponse
     */
    'result': OrderIdsResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface OrderIdsResponseAllOfResult
 */
export interface OrderIdsResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderIdsResponseAllOfResult
     */
    'orderIds': Array<string>;
}
/**
 * 発注番号一覧取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface OrderNumbersResponse
 */
export interface OrderNumbersResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderNumbersResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderNumbersResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderNumbersResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderNumbersResponseAllOfResult}
     * @memberof OrderNumbersResponse
     */
    'result': OrderNumbersResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface OrderNumbersResponseAllOfResult
 */
export interface OrderNumbersResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderNumbersResponseAllOfResult
     */
    'orderNumbers': Array<string>;
}
/**
 * リクエストに含める発注ステータスのフィルター項目の型 (発注管理画面用)
 * @export
 * @interface OrderStatusFilterItemForOrderBusiness
 */
export interface OrderStatusFilterItemForOrderBusiness {
    /**
     * 推奨
     * @type {boolean}
     * @memberof OrderStatusFilterItemForOrderBusiness
     */
    'Recommended': boolean;
    /**
     * 承認依頼
     * @type {boolean}
     * @memberof OrderStatusFilterItemForOrderBusiness
     */
    'ApprovalRequested': boolean;
    /**
     * 承認済
     * @type {boolean}
     * @memberof OrderStatusFilterItemForOrderBusiness
     */
    'ApprovedAwaitingDeliveryDate': boolean;
    /**
     * 非表示中の推奨のみ表示
     * @type {boolean}
     * @memberof OrderStatusFilterItemForOrderBusiness
     */
    'HiddenRecommend'?: boolean;
}
/**
 * 発注テンプレートの詳細情報
 * @export
 * @interface OrderTemplateDetail
 */
export interface OrderTemplateDetail {
    /**
     * 
     * @type {OrderTemplateMetadata}
     * @memberof OrderTemplateDetail
     */
    'metadata': OrderTemplateMetadata;
    /**
     * 
     * @type {Array<OrderTemplateMapping>}
     * @memberof OrderTemplateDetail
     */
    'mappings': Array<OrderTemplateMapping>;
}
/**
 * テンプレート詳細レスポンス
 * @export
 * @interface OrderTemplateDetailResult
 */
export interface OrderTemplateDetailResult {
    /**
     * 
     * @type {OrderTemplateDetail}
     * @memberof OrderTemplateDetailResult
     */
    'template': OrderTemplateDetail;
}
/**
 * テンプレート一覧レスポンス
 * @export
 * @interface OrderTemplateListResult
 */
export interface OrderTemplateListResult {
    /**
     * 
     * @type {Array<OrderTemplateSummary>}
     * @memberof OrderTemplateListResult
     */
    'templates': Array<OrderTemplateSummary>;
}
/**
 * テンプレートのセルマッピング
 * @export
 * @interface OrderTemplateMapping
 */
export interface OrderTemplateMapping {
    /**
     * マッピングID
     * @type {number}
     * @memberof OrderTemplateMapping
     */
    'mappingId': number;
    /**
     * テンプレートID
     * @type {string}
     * @memberof OrderTemplateMapping
     */
    'templateId': string;
    /**
     * 出力対象項目のフィールドキー
     * @type {string}
     * @memberof OrderTemplateMapping
     */
    'fieldKey': string;
    /**
     * 出力開始セル
     * @type {string}
     * @memberof OrderTemplateMapping
     */
    'startCell': string;
    /**
     * 作成日時(UNIX time)
     * @type {number}
     * @memberof OrderTemplateMapping
     */
    'createAt'?: number;
    /**
     * 更新日時(UNIX time)
     * @type {number}
     * @memberof OrderTemplateMapping
     */
    'updateAt'?: number;
}
/**
 * セルマッピングの登録・更新情報
 * @export
 * @interface OrderTemplateMappingWrite
 */
export interface OrderTemplateMappingWrite {
    /**
     * 既存レコード更新時のマッピングID
     * @type {number}
     * @memberof OrderTemplateMappingWrite
     */
    'mappingId'?: number;
    /**
     * 出力対象項目のフィールドキー
     * @type {string}
     * @memberof OrderTemplateMappingWrite
     */
    'fieldKey': string;
    /**
     * 出力開始セル
     * @type {string}
     * @memberof OrderTemplateMappingWrite
     */
    'startCell': string;
}
/**
 * テンプレートのメタ情報
 * @export
 * @interface OrderTemplateMetadata
 */
export interface OrderTemplateMetadata {
    /**
     * テンプレートID
     * @type {string}
     * @memberof OrderTemplateMetadata
     */
    'templateId': string;
    /**
     * 所属組織ID
     * @type {string}
     * @memberof OrderTemplateMetadata
     */
    'organizationId': string;
    /**
     * アップロード時のファイル名
     * @type {string}
     * @memberof OrderTemplateMetadata
     */
    'fileOriginalName': string;
    /**
     * S3上の保存パス
     * @type {string}
     * @memberof OrderTemplateMetadata
     */
    'storagePath': string;
    /**
     * 1シートあたりの出力上限
     * @type {number}
     * @memberof OrderTemplateMetadata
     */
    'maxOrdersPerSheet': number;
    /**
     * 既定のシート名
     * @type {string}
     * @memberof OrderTemplateMetadata
     */
    'defaultSheetName'?: string;
    /**
     * 作成者ユーザーID
     * @type {string}
     * @memberof OrderTemplateMetadata
     */
    'createdBy': string;
    /**
     * 更新者ユーザーID
     * @type {string}
     * @memberof OrderTemplateMetadata
     */
    'updatedBy': string;
    /**
     * 作成日時(UNIX time)
     * @type {number}
     * @memberof OrderTemplateMetadata
     */
    'createAt': number;
    /**
     * 更新日時(UNIX time)
     * @type {number}
     * @memberof OrderTemplateMetadata
     */
    'updateAt': number;
    /**
     * 論理ゴミ箱状態
     * @type {boolean}
     * @memberof OrderTemplateMetadata
     */
    'isTrashed'?: boolean;
    /**
     * 論理削除状態
     * @type {boolean}
     * @memberof OrderTemplateMetadata
     */
    'isDeleted'?: boolean;
}
/**
 * Presigned URLレスポンス(ダウンロード)
 * @export
 * @interface OrderTemplatePresignedDownloadResponse
 */
export interface OrderTemplatePresignedDownloadResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderTemplatePresignedDownloadResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTemplatePresignedDownloadResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplatePresignedDownloadResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderTemplatePresignedDownloadResult}
     * @memberof OrderTemplatePresignedDownloadResponse
     */
    'result': OrderTemplatePresignedDownloadResult;
}
/**
 * Presigned URL(ダウンロード)の詳細
 * @export
 * @interface OrderTemplatePresignedDownloadResult
 */
export interface OrderTemplatePresignedDownloadResult {
    /**
     * ダウンロード用URL
     * @type {string}
     * @memberof OrderTemplatePresignedDownloadResult
     */
    'url': string;
    /**
     * URLの有効期限
     * @type {string}
     * @memberof OrderTemplatePresignedDownloadResult
     */
    'expiresAt': string;
    /**
     * 推奨ダウンロードファイル名
     * @type {string}
     * @memberof OrderTemplatePresignedDownloadResult
     */
    'fileName'?: string;
    /**
     * ファイルのContent-Type
     * @type {string}
     * @memberof OrderTemplatePresignedDownloadResult
     */
    'contentType'?: string;
}
/**
 * Presigned URL発行リクエスト(アップロード)
 * @export
 * @interface OrderTemplatePresignedUploadRequest
 */
export interface OrderTemplatePresignedUploadRequest {
    /**
     * アップロードするファイル名
     * @type {string}
     * @memberof OrderTemplatePresignedUploadRequest
     */
    'fileName': string;
    /**
     * ファイルのContent-Type
     * @type {string}
     * @memberof OrderTemplatePresignedUploadRequest
     */
    'contentType': string;
    /**
     * ファイルサイズ(Byte)
     * @type {number}
     * @memberof OrderTemplatePresignedUploadRequest
     */
    'fileSize': number;
}
/**
 * Presigned URLレスポンス(アップロード)
 * @export
 * @interface OrderTemplatePresignedUploadResponse
 */
export interface OrderTemplatePresignedUploadResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderTemplatePresignedUploadResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTemplatePresignedUploadResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplatePresignedUploadResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderTemplatePresignedUploadResult}
     * @memberof OrderTemplatePresignedUploadResponse
     */
    'result': OrderTemplatePresignedUploadResult;
}
/**
 * Presigned URL(アップロード)の詳細
 * @export
 * @interface OrderTemplatePresignedUploadResult
 */
export interface OrderTemplatePresignedUploadResult {
    /**
     * アップロード先URL
     * @type {string}
     * @memberof OrderTemplatePresignedUploadResult
     */
    'url': string;
    /**
     * Presigned POSTに使用するフィールド群
     * @type {{ [key: string]: string; }}
     * @memberof OrderTemplatePresignedUploadResult
     */
    'fields': { [key: string]: string; };
    /**
     * URLの有効期限
     * @type {string}
     * @memberof OrderTemplatePresignedUploadResult
     */
    'expiresAt': string;
    /**
     * S3に保存されるキー
     * @type {string}
     * @memberof OrderTemplatePresignedUploadResult
     */
    's3Key': string;
    /**
     * 生成されたテンプレートID
     * @type {string}
     * @memberof OrderTemplatePresignedUploadResult
     */
    'templateId': string;
}
/**
 * テンプレート一覧表示用情報
 * @export
 * @interface OrderTemplateSummary
 */
export interface OrderTemplateSummary {
    /**
     * テンプレートID
     * @type {string}
     * @memberof OrderTemplateSummary
     */
    'templateId': string;
    /**
     * アップロード時のファイル名
     * @type {string}
     * @memberof OrderTemplateSummary
     */
    'fileOriginalName': string;
    /**
     * S3上の保存パス
     * @type {string}
     * @memberof OrderTemplateSummary
     */
    'storagePath': string;
    /**
     * 1シートあたりの出力上限
     * @type {number}
     * @memberof OrderTemplateSummary
     */
    'maxOrdersPerSheet': number;
    /**
     * 既定のシート名
     * @type {string}
     * @memberof OrderTemplateSummary
     */
    'defaultSheetName'?: string;
    /**
     * 作成者ユーザーID
     * @type {string}
     * @memberof OrderTemplateSummary
     */
    'createdBy': string;
    /**
     * 更新者ユーザーID
     * @type {string}
     * @memberof OrderTemplateSummary
     */
    'updatedBy': string;
    /**
     * 更新者の表示名
     * @type {string}
     * @memberof OrderTemplateSummary
     */
    'updatedByName'?: string;
    /**
     * 作成日時(UNIX time)
     * @type {number}
     * @memberof OrderTemplateSummary
     */
    'createAt': number;
    /**
     * 更新日時(UNIX time)
     * @type {number}
     * @memberof OrderTemplateSummary
     */
    'updateAt': number;
    /**
     * 論理ゴミ箱状態
     * @type {boolean}
     * @memberof OrderTemplateSummary
     */
    'isTrashed'?: boolean;
    /**
     * 論理削除状態
     * @type {boolean}
     * @memberof OrderTemplateSummary
     */
    'isDeleted'?: boolean;
}
/**
 * テンプレート登録・更新リクエスト
 * @export
 * @interface OrderTemplateUpsertRequest
 */
export interface OrderTemplateUpsertRequest {
    /**
     * 
     * @type {OrderTemplateUpsertTemplate}
     * @memberof OrderTemplateUpsertRequest
     */
    'template': OrderTemplateUpsertTemplate;
    /**
     * セルマッピング一覧
     * @type {Array<OrderTemplateMappingWrite>}
     * @memberof OrderTemplateUpsertRequest
     */
    'mappings'?: Array<OrderTemplateMappingWrite>;
}
/**
 * テンプレート登録・更新用メタ情報
 * @export
 * @interface OrderTemplateUpsertTemplate
 */
export interface OrderTemplateUpsertTemplate {
    /**
     * テンプレートID
     * @type {string}
     * @memberof OrderTemplateUpsertTemplate
     */
    'templateId': string;
    /**
     * アップロード時のファイル名
     * @type {string}
     * @memberof OrderTemplateUpsertTemplate
     */
    'fileOriginalName': string;
    /**
     * S3に保存したテンプレートパス
     * @type {string}
     * @memberof OrderTemplateUpsertTemplate
     */
    'storagePath': string;
    /**
     * 1シートあたりの出力上限
     * @type {number}
     * @memberof OrderTemplateUpsertTemplate
     */
    'maxOrdersPerSheet': number;
    /**
     * 既定のシート名
     * @type {string}
     * @memberof OrderTemplateUpsertTemplate
     */
    'defaultSheetName'?: string;
}
/**
 * エクセル出力する発注情報
 * @export
 * @interface OutputOrderInfo
 */
export interface OutputOrderInfo {
    /**
     * 発注ID
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'orderId': string;
    /**
     * 発注日
     * @type {number}
     * @memberof OutputOrderInfo
     */
    'createdOrderDate'?: number;
    /**
     * 発注数量
     * @type {number}
     * @memberof OutputOrderInfo
     */
    'orderAmount': number;
    /**
     * 希望納期
     * @type {number}
     * @memberof OutputOrderInfo
     */
    'desiredDeliveryDate': number;
    /**
     * 納入日
     * @type {number}
     * @memberof OutputOrderInfo
     */
    'estimatedTimeOfArrival': number;
    /**
     * 港納期(Port ETA)
     * @type {number}
     * @memberof OutputOrderInfo
     */
    'portEta'?: number | null;
    /**
     * 倉庫CD
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'warehouseNumber': string;
    /**
     * 倉庫名
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'warehouse': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'supplierName': string;
    /**
     * 製造社
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'manufacturer': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'businessName': string;
    /**
     * 容量
     * @type {number}
     * @memberof OutputOrderInfo
     */
    'package': number;
    /**
     * 単位
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'unit': string;
    /**
     * 発注管理番号
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'orderIssuedNumber'?: string;
    /**
     * 発注番号
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'orderNumber': string;
    /**
     * 集計取引担当者リスト
     * @type {Array<UserData>}
     * @memberof OutputOrderInfo
     */
    'aggregateBusinessResponsibleUsers': Array<UserData>;
    /**
     * 発注メモ (任意)
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'orderNote': string;
    /**
     * 発注グループ名
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'orderGroupName'?: string;
    /**
     * インボイス番号
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'invoiceNumber'?: string;
    /**
     * 仕向地
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'destinationName'?: string;
    /**
     * key,value形式のユーザー任意項目(24/8/23 現状、顧客台帳ID用を想定)
     * @type {{ [key: string]: string; }}
     * @memberof OutputOrderInfo
     */
    'userCustomParameters': { [key: string]: string; };
    /**
     * 仕入単価
     * @type {string}
     * @memberof OutputOrderInfo
     */
    'purchaseUnitPrice'?: string | null;
}
/**
 * 発注帳票出力リクエスト
 * @export
 * @interface OutputOrderRequest
 */
export interface OutputOrderRequest {
    /**
     * 出力対象とする発注ID一覧
     * @type {Array<string>}
     * @memberof OutputOrderRequest
     */
    'targetOrderIds': Array<string>;
    /**
     * 
     * @type {OutputOrderTemplateRequest}
     * @memberof OutputOrderRequest
     */
    'template'?: OutputOrderTemplateRequest;
    /**
     * 
     * @type {OutputOrderRequestOptions}
     * @memberof OutputOrderRequest
     */
    'options'?: OutputOrderRequestOptions;
}
/**
 * 帳票出力時の追加オプション
 * @export
 * @interface OutputOrderRequestOptions
 */
export interface OutputOrderRequestOptions {
    /**
     * ZIP圧縮へ切り替える発注件数の閾値
     * @type {number}
     * @memberof OutputOrderRequestOptions
     */
    'archiveThreshold'?: number;
    /**
     * カスタムパラメータを出力リストに含めるか
     * @type {boolean}
     * @memberof OutputOrderRequestOptions
     */
    'includeUserCustomParameters'?: boolean;
}
/**
 * 発注情報のテンプレートExcelを取得するレスポンス
 * @export
 * @interface OutputOrderResponse
 */
export interface OutputOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof OutputOrderResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OutputOrderResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OutputOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {OutputOrderResponseResult}
     * @memberof OutputOrderResponse
     */
    'result': OutputOrderResponseResult;
}
/**
 * 発注情報のテンプレートExcelを取得するレスポンスの型定義
 * @export
 * @interface OutputOrderResponseResult
 */
export interface OutputOrderResponseResult {
    /**
     * 
     * @type {OutputOrderResponseResultData}
     * @memberof OutputOrderResponseResult
     */
    'data': OutputOrderResponseResultData;
}
/**
 * 発注情報の帳票出力レスポンスで返す情報
 * @export
 * @interface OutputOrderResponseResultData
 */
export interface OutputOrderResponseResultData {
    /**
     * 互換性維持用の出力ファイル(非推奨)
     * @type {string}
     * @memberof OutputOrderResponseResultData
     */
    'excelFile'?: string;
    /**
     * 出力ファイル本体のBase64エンコード文字列
     * @type {string}
     * @memberof OutputOrderResponseResultData
     */
    'fileContent': string;
    /**
     * 出力ファイルのMIMEタイプ
     * @type {string}
     * @memberof OutputOrderResponseResultData
     */
    'fileContentType': string;
    /**
     * 推奨ダウンロードファイル名
     * @type {string}
     * @memberof OutputOrderResponseResultData
     */
    'fileName'?: string;
    /**
     * 圧縮済みファイルの場合の圧縮形式
     * @type {string}
     * @memberof OutputOrderResponseResultData
     */
    'compressionType'?: string;
    /**
     * 
     * @type {OutputOrderTemplateInfo}
     * @memberof OutputOrderResponseResultData
     */
    'template'?: OutputOrderTemplateInfo;
    /**
     * エクセル出力する発注情報の配列
     * @type {Array<OutputOrderInfo>}
     * @memberof OutputOrderResponseResultData
     */
    'outputOrderList': Array<OutputOrderInfo>;
}
/**
 * 発注帳票の生成に利用したテンプレート情報
 * @export
 * @interface OutputOrderTemplateInfo
 */
export interface OutputOrderTemplateInfo {
    /**
     * 利用したテンプレートID
     * @type {string}
     * @memberof OutputOrderTemplateInfo
     */
    'templateId': string;
}
/**
 * 帳票出力で利用するテンプレート指定
 * @export
 * @interface OutputOrderTemplateRequest
 */
export interface OutputOrderTemplateRequest {
    /**
     * 利用するテンプレートID
     * @type {string}
     * @memberof OutputOrderTemplateRequest
     */
    'templateId': string;
}
/**
 * APIから受け取るpagingOptionsの情報
 * @export
 * @interface PagingOptions
 */
export interface PagingOptions {
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'nextOffset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'totalResultsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'returnCount': number;
}
/**
 * 分納データを表すスキーマ
 * @export
 * @interface PartialDeliveryRequest
 */
export interface PartialDeliveryRequest {
    /**
     * 分納ID
     * @type {string}
     * @memberof PartialDeliveryRequest
     */
    'partialDeliveryId': string;
    /**
     * ユーザーが設定する発注番号
     * @type {string}
     * @memberof PartialDeliveryRequest
     */
    'partialDeliveryNumber': string;
    /**
     * 納期
     * @type {string}
     * @memberof PartialDeliveryRequest
     */
    'deliveryDate': string;
    /**
     * 発注数量
     * @type {number}
     * @memberof PartialDeliveryRequest
     */
    'orderAmount': number;
    /**
     * 分納の発注ステータス
     * @type {string}
     * @memberof PartialDeliveryRequest
     */
    'partialDeliveryStatus': string;
    /**
     * レコードの最終更新日時（Unixタイムスタンプ）
     * @type {number}
     * @memberof PartialDeliveryRequest
     */
    'updatedAt'?: number | null;
}
/**
 * 分納データを表すスキーマ
 * @export
 * @interface PartialDeliveryResponse
 */
export interface PartialDeliveryResponse {
    /**
     * 分納ID
     * @type {string}
     * @memberof PartialDeliveryResponse
     */
    'partialDeliveryId': string;
    /**
     * 組織ID
     * @type {string}
     * @memberof PartialDeliveryResponse
     */
    'organizationId': string;
    /**
     * 親の発注ID
     * @type {string}
     * @memberof PartialDeliveryResponse
     */
    'orderId': string;
    /**
     * 親の集計ID
     * @type {string}
     * @memberof PartialDeliveryResponse
     */
    'aggregateBusinessId': string;
    /**
     * ユーザーが設定する発注番号
     * @type {string}
     * @memberof PartialDeliveryResponse
     */
    'partialDeliveryNumber': string;
    /**
     * 発注が作成された日時（Unixタイムスタンプ）
     * @type {number}
     * @memberof PartialDeliveryResponse
     */
    'orderCreationTime'?: number;
    /**
     * 納期（Unixタイムスタンプ）
     * @type {number}
     * @memberof PartialDeliveryResponse
     */
    'estimatedTimeOfArrival'?: number;
    /**
     * 発注数量
     * @type {number}
     * @memberof PartialDeliveryResponse
     */
    'orderAmount'?: number;
    /**
     * 分納の発注ステータス
     * @type {string}
     * @memberof PartialDeliveryResponse
     */
    'partialDeliveryStatus': string;
    /**
     * アラートに使用する在庫不足フラグ
     * @type {boolean}
     * @memberof PartialDeliveryResponse
     */
    'isOutOfStockExpected': boolean;
    /**
     * 
     * @type {UserData}
     * @memberof PartialDeliveryResponse
     */
    'lastUpdatedByUser': UserData;
    /**
     * レコードの作成日時（Unixタイムスタンプ）
     * @type {number}
     * @memberof PartialDeliveryResponse
     */
    'createdAt': number;
    /**
     * レコードの最終更新日時（Unixタイムスタンプ）
     * @type {number}
     * @memberof PartialDeliveryResponse
     */
    'updateAt': number;
}
/**
 * postメソッドで投げる、登録される発注情報の型
 * @export
 * @interface PostOrderRequestInfo
 */
export interface PostOrderRequestInfo {
    /**
     * ローカルの表示用ID (登録完了したときのorderIDと紐づけるために使う。シミュレーション画面でしか現状使っていない。それ以外の画面ではnullを送る)
     * @type {string}
     * @memberof PostOrderRequestInfo
     */
    'displayId'?: string;
    /**
     * 発注ID (DBに登録されている発注情報は発注IDを持たせる。新規登録は空埋め)
     * @type {string}
     * @memberof PostOrderRequestInfo
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostOrderRequestInfo
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {string}
     * @memberof PostOrderRequestInfo
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostOrderRequestInfo
     */
    'desiredDeliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof PostOrderRequestInfo
     */
    'estimatedTimeOfArrival': string;
    /**
     * 
     * @type {number}
     * @memberof PostOrderRequestInfo
     */
    'orderAmount': number;
    /**
     * 
     * @type {string}
     * @memberof PostOrderRequestInfo
     */
    'orderStatus': string;
    /**
     * 
     * @type {boolean}
     * @memberof PostOrderRequestInfo
     */
    'outputManageFlg'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostOrderRequestInfo
     */
    'orderNote'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostOrderRequestInfo
     */
    'updateAt'?: number;
}
/**
 * postした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface PostOrderResponse
 */
export interface PostOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PostOrderResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostOrderResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {PostOrderResponseResult}
     * @memberof PostOrderResponse
     */
    'result': PostOrderResponseResult;
}
/**
 * 発注登録APIのレスポンスの型定義
 * @export
 * @interface PostOrderResponseResult
 */
export interface PostOrderResponseResult {
    /**
     * 
     * @type {string}
     * @memberof PostOrderResponseResult
     */
    'orderId'?: string;
}
/**
 * 発注テンプレート登録レスポンス
 * @export
 * @interface PostOrderTemplateResponse
 */
export interface PostOrderTemplateResponse {
    /**
     * 
     * @type {number}
     * @memberof PostOrderTemplateResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostOrderTemplateResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostOrderTemplateResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderTemplateDetailResult}
     * @memberof PostOrderTemplateResponse
     */
    'result': OrderTemplateDetailResult;
}
/**
 * 発注テンプレート更新レスポンス
 * @export
 * @interface PutOrderTemplateResponse
 */
export interface PutOrderTemplateResponse {
    /**
     * 
     * @type {number}
     * @memberof PutOrderTemplateResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PutOrderTemplateResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PutOrderTemplateResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderTemplateDetailResult}
     * @memberof PutOrderTemplateResponse
     */
    'result': OrderTemplateDetailResult;
}
/**
 * 発注取引が持つ発注情報
 * @export
 * @interface RegisterOrderBusinessDurationOrderInfo
 */
export interface RegisterOrderBusinessDurationOrderInfo {
    /**
     * 発注番号(伝票NO)
     * @type {string}
     * @memberof RegisterOrderBusinessDurationOrderInfo
     */
    'orderNumber'?: string;
    /**
     * 自動採番の発注番号(買い発注番号)
     * @type {string}
     * @memberof RegisterOrderBusinessDurationOrderInfo
     */
    'orderIssuedNumber'?: string;
    /**
     * 受注日(確定発注日)
     * @type {string}
     * @memberof RegisterOrderBusinessDurationOrderInfo
     */
    'createdOrderDate'?: string;
    /**
     * 希望納期
     * @type {string}
     * @memberof RegisterOrderBusinessDurationOrderInfo
     */
    'desiredDeliveryDate'?: string;
    /**
     * 納入日
     * @type {string}
     * @memberof RegisterOrderBusinessDurationOrderInfo
     */
    'estimatedTimeOfArrival'?: string;
    /**
     * 数量
     * @type {number}
     * @memberof RegisterOrderBusinessDurationOrderInfo
     */
    'orderAmount'?: number;
    /**
     * 発注ステータス
     * @type {string}
     * @memberof RegisterOrderBusinessDurationOrderInfo
     */
    'orderStatus'?: string;
}
/**
 * 登録する発注取引の情報
 * @export
 * @interface RegisterOrderBusinessInfo
 */
export interface RegisterOrderBusinessInfo {
    /**
     * 仕入先CD
     * @type {string}
     * @memberof RegisterOrderBusinessInfo
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof RegisterOrderBusinessInfo
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof RegisterOrderBusinessInfo
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof RegisterOrderBusinessInfo
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof RegisterOrderBusinessInfo
     */
    'package'?: number;
    /**
     * 置場CD
     * @type {string}
     * @memberof RegisterOrderBusinessInfo
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof RegisterOrderBusinessInfo
     */
    'warehouse'?: string;
    /**
     * 
     * @type {Array<RegisterOrderBusinessDurationOrderInfo>}
     * @memberof RegisterOrderBusinessInfo
     */
    'orders': Array<RegisterOrderBusinessDurationOrderInfo>;
}
/**
 * ソート種別
 * @export
 * @enum {string}
 */

export const SortType = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortType = typeof SortType[keyof typeof SortType];


/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 
 * @export
 * @interface UpdateOrderInfoRequest
 */
export interface UpdateOrderInfoRequest {
    /**
     * 
     * @type {EditableProperties}
     * @memberof UpdateOrderInfoRequest
     */
    'putOrderInfo': EditableProperties;
}
/**
 * 発注メモの更新を行う情報
 * @export
 * @interface UpdateOrderMemoInfo
 */
export interface UpdateOrderMemoInfo {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderMemoInfo
     */
    'orderMemo': string;
}
/**
 * 
 * @export
 * @interface UpdateOrderMemoRequest
 */
export interface UpdateOrderMemoRequest {
    /**
     * 
     * @type {UpdateOrderMemoInfo}
     * @memberof UpdateOrderMemoRequest
     */
    'orderMemoInfo': UpdateOrderMemoInfo;
}
/**
 * putした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface UpdateOrderResponse
 */
export interface UpdateOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {UpdateOrderResponseResult}
     * @memberof UpdateOrderResponse
     */
    'result': UpdateOrderResponseResult;
}
/**
 * APIから受け取るレスポンスの型
 * @export
 * @interface UpdateOrderResponseResult
 */
export interface UpdateOrderResponseResult {
    /**
     * APIから受け取る更新された発注ID一覧
     * @type {Array<UpdateOrderResponseResultData>}
     * @memberof UpdateOrderResponseResult
     */
    'data': Array<UpdateOrderResponseResultData>;
}
/**
 * APIから受け取る更新された発注ID
 * @export
 * @interface UpdateOrderResponseResultData
 */
export interface UpdateOrderResponseResultData {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderResponseResultData
     */
    'orderId': string;
}
/**
 * 編集項目の配列
 * @export
 * @interface UpdateOrderStatusInfo
 */
export interface UpdateOrderStatusInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOrderStatusInfo
     */
    'orderIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderStatusInfo
     */
    'orderStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateOrderStatusRequest
 */
export interface UpdateOrderStatusRequest {
    /**
     * 
     * @type {UpdateOrderStatusInfo}
     * @memberof UpdateOrderStatusRequest
     */
    'putOrderInfo'?: UpdateOrderStatusInfo;
}
/**
 * 
 * @export
 * @interface UpdateOutputFlagRequest
 */
export interface UpdateOutputFlagRequest {
    /**
     * 発注フラグの更新を行う発注IDの配列
     * @type {Array<string>}
     * @memberof UpdateOutputFlagRequest
     */
    'orderIds': Array<string>;
    /**
     * trueなら出力済み(出力日時を現在時刻に更新)、falseなら未出力(出力日時をクリア)にする。省略時はtrue
     * @type {boolean}
     * @memberof UpdateOutputFlagRequest
     */
    'isOutput'?: boolean;
}
/**
 * postメソッドで投げる、登録される発注情報の型
 * @export
 * @interface UpsertAndSingleSimulationOrderRequestInfo
 */
export interface UpsertAndSingleSimulationOrderRequestInfo {
    /**
     * 
     * @type {UpsertOrderInfo}
     * @memberof UpsertAndSingleSimulationOrderRequestInfo
     */
    'upsertOrderInfo': UpsertOrderInfo;
    /**
     * 
     * @type {string}
     * @memberof UpsertAndSingleSimulationOrderRequestInfo
     */
    'aggregateBusinessId': string;
    /**
     * ローカルの表示用ID (登録完了したときのorderIDと紐づけるために使う。シミュレーション画面でしか現状使っていない。それ以外の画面ではnullを送る)
     * @type {string}
     * @memberof UpsertAndSingleSimulationOrderRequestInfo
     */
    'displayId'?: string;
    /**
     * 
     * @type {OrderBasisAdjustedInfo}
     * @memberof UpsertAndSingleSimulationOrderRequestInfo
     */
    'orderBasisAdjustment': OrderBasisAdjustedInfo;
}
/**
 * upsertした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface UpsertAndSingleSimulationOrderResponse
 */
export interface UpsertAndSingleSimulationOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof UpsertAndSingleSimulationOrderResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpsertAndSingleSimulationOrderResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertAndSingleSimulationOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {UpsertAndSingleSimulationOrderResponseResult}
     * @memberof UpsertAndSingleSimulationOrderResponse
     */
    'result': UpsertAndSingleSimulationOrderResponseResult;
}
/**
 * 発注登録APIのレスポンスの型定義
 * @export
 * @interface UpsertAndSingleSimulationOrderResponseResult
 */
export interface UpsertAndSingleSimulationOrderResponseResult {
    /**
     * 発注ID
     * @type {string}
     * @memberof UpsertAndSingleSimulationOrderResponseResult
     */
    'orderId': string;
    /**
     * 集計ID
     * @type {string}
     * @memberof UpsertAndSingleSimulationOrderResponseResult
     */
    'aggregateBusinessId'?: string;
    /**
     * ローカルの表示用ID (登録完了したときのorderIDと紐づけるために使う。シミュレーション画面でしか現状使っていない。それ以外の画面ではnullを送る)
     * @type {string}
     * @memberof UpsertAndSingleSimulationOrderResponseResult
     */
    'displayId'?: string;
    /**
     * 推奨発注日 (推奨発注の時はnull)
     * @type {number}
     * @memberof UpsertAndSingleSimulationOrderResponseResult
     */
    'recommendCreatedOrderDate'?: number;
    /**
     * 推奨納入日 (推奨発注の時はnull)
     * @type {number}
     * @memberof UpsertAndSingleSimulationOrderResponseResult
     */
    'recommendEstimateTime'?: number;
    /**
     * 推奨発注数量 (推奨発注の時はnull)
     * @type {number}
     * @memberof UpsertAndSingleSimulationOrderResponseResult
     */
    'recommendArrivalValue'?: number;
}
/**
 * postメソッドで投げる、登録される発注情報の型
 * @export
 * @interface UpsertOrderInfo
 */
export interface UpsertOrderInfo {
    /**
     * 発注ID (DBに登録されている発注情報は発注IDを持たせる。新規登録は空埋め)
     * @type {string}
     * @memberof UpsertOrderInfo
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrderInfo
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrderInfo
     */
    'desiredDeliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrderInfo
     */
    'estimatedTimeOfArrival': string;
    /**
     * 
     * @type {number}
     * @memberof UpsertOrderInfo
     */
    'orderAmount': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrderInfo
     */
    'orderStatus': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrderInfo
     */
    'orderNote'?: string;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface UseFilterItem
 */
export interface UseFilterItem {
    /**
     * 取引ID
     * @type {string}
     * @memberof UseFilterItem
     */
    'orderId'?: string;
    /**
     * 自動採番の番号
     * @type {string}
     * @memberof UseFilterItem
     */
    'orderIssuedNumber'?: string;
    /**
     * 発注番号
     * @type {string}
     * @memberof UseFilterItem
     */
    'orderNumber'?: string;
    /**
     * 発注数量
     * @type {string}
     * @memberof UseFilterItem
     */
    'orderAmount'?: string;
    /**
     * 発注日
     * @type {string}
     * @memberof UseFilterItem
     */
    'createdOrderDate'?: string;
    /**
     * 希望納期
     * @type {string}
     * @memberof UseFilterItem
     */
    'desiredDeliveryDate'?: string;
    /**
     * 納期
     * @type {string}
     * @memberof UseFilterItem
     */
    'estimatedTimeOfArrival'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof UseFilterItem
     */
    'businessName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'businessNumber'?: string;
    /**
     * 置場CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof UseFilterItem
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'supplierName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof UseFilterItem
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof UseFilterItem
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof UseFilterItem
     */
    'manufacturer'?: string;
    /**
     * グループID
     * @type {string}
     * @memberof UseFilterItem
     */
    'groupId'?: string;
    /**
     * 集計取引担当者ID
     * @type {string}
     * @memberof UseFilterItem
     */
    'aggregateBusinessResponsibleUserId'?: string;
    /**
     * 発注グループ名
     * @type {string}
     * @memberof UseFilterItem
     */
    'orderGroupName'?: string;
    /**
     * インボイス番号
     * @type {string}
     * @memberof UseFilterItem
     */
    'invoiceNumber'?: string;
    /**
     * 仕向地
     * @type {string}
     * @memberof UseFilterItem
     */
    'destinationName'?: string;
    /**
     * 発注日From(ms)
     * @type {number}
     * @memberof UseFilterItem
     */
    'createdOrderDateFrom'?: number;
    /**
     * 発注日To(ms)
     * @type {number}
     * @memberof UseFilterItem
     */
    'createdOrderDateTo'?: number;
    /**
     * 発注日が未設定のデータも含める
     * @type {boolean}
     * @memberof UseFilterItem
     */
    'createdOrderDateIncludeNull'?: boolean;
    /**
     * 希望納期From(ms)
     * @type {number}
     * @memberof UseFilterItem
     */
    'desiredDeliveryDateFrom'?: number;
    /**
     * 希望納期To(ms)
     * @type {number}
     * @memberof UseFilterItem
     */
    'desiredDeliveryDateTo'?: number;
    /**
     * 希望納期が未設定のデータも含める
     * @type {boolean}
     * @memberof UseFilterItem
     */
    'desiredDeliveryDateIncludeNull'?: boolean;
    /**
     * 納期From(ms)
     * @type {number}
     * @memberof UseFilterItem
     */
    'estimatedTimeOfArrivalFrom'?: number;
    /**
     * 納期To(ms)
     * @type {number}
     * @memberof UseFilterItem
     */
    'estimatedTimeOfArrivalTo'?: number;
    /**
     * 納期が未設定のデータも含める
     * @type {boolean}
     * @memberof UseFilterItem
     */
    'estimatedTimeOfArrivalIncludeNull'?: boolean;
    /**
     * 最終チェック日時(開始, ms)
     * @type {number}
     * @memberof UseFilterItem
     */
    'lastCheckedAtFrom'?: number;
    /**
     * 最終チェック日時(終了, ms)
     * @type {number}
     * @memberof UseFilterItem
     */
    'lastCheckedAtTo'?: number;
    /**
     * 最終チェック日時が未設定のデータも含める
     * @type {boolean}
     * @memberof UseFilterItem
     */
    'lastCheckedAtIncludeNull'?: boolean;
}
/**
 * リクエストに含めるフィルター項目の型 (発注管理ページ用)
 * @export
 * @interface UseFilterItemForOrderBusiness
 */
export interface UseFilterItemForOrderBusiness {
    /**
     * 発注数量
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'orderAmount'?: string;
    /**
     * 発注日
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'createdOrderDate'?: string;
    /**
     * 希望納期
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'desiredDeliveryDate'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'businessName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'businessNumber'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof UseFilterItemForOrderBusiness
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'manufacturer'?: string;
    /**
     * 置場CD
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'supplierName'?: string;
    /**
     * 集計取引担当者ID
     * @type {string}
     * @memberof UseFilterItemForOrderBusiness
     */
    'aggregateBusinessResponsibleUserId'?: string;
    /**
     * 最終チェック日時(開始, ms)
     * @type {number}
     * @memberof UseFilterItemForOrderBusiness
     */
    'lastCheckedAtFrom'?: number;
    /**
     * 最終チェック日時(終了, ms)
     * @type {number}
     * @memberof UseFilterItemForOrderBusiness
     */
    'lastCheckedAtTo'?: number;
    /**
     * 最終チェック日時が未設定のデータも含める
     * @type {boolean}
     * @memberof UseFilterItemForOrderBusiness
     */
    'lastCheckedAtIncludeNull'?: boolean;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}

/**
 * GetOrderBusinessApi - axios parameter creator
 * @export
 */
export const GetOrderBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注管理画面表示情報の取得
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItemForOrderBusiness} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {OrderStatusFilterItemForOrderBusiness} [orderStatusFilterItem] 発注ステータスのフィルター (承認依頼、承認済みのみ)
         * @param {string} [aggregateFreeColumns] [{columnIndex: number, selectedValues: (string | null)[]}]形式のJSONをzlibで圧縮した集計取引自由カラムのフィルター情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBusiness: async (sortType: SortType, limit: number, offset: number, sortTarget?: string, filterItem?: UseFilterItemForOrderBusiness, filterItemObject?: ObjectFilterInfo, orderStatusFilterItem?: OrderStatusFilterItemForOrderBusiness, aggregateFreeColumns?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getOrderBusiness', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getOrderBusiness', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getOrderBusiness', 'offset', offset)
            const localVarPath = `/order-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filterItemObject !== undefined) {
                for (const [key, value] of Object.entries(filterItemObject)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (orderStatusFilterItem !== undefined) {
                for (const [key, value] of Object.entries(orderStatusFilterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (aggregateFreeColumns !== undefined) {
                localVarQueryParameter['aggregateFreeColumns'] = aggregateFreeColumns;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetOrderBusinessApi - functional programming interface
 * @export
 */
export const GetOrderBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetOrderBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注管理画面表示情報の取得
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItemForOrderBusiness} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {OrderStatusFilterItemForOrderBusiness} [orderStatusFilterItem] 発注ステータスのフィルター (承認依頼、承認済みのみ)
         * @param {string} [aggregateFreeColumns] [{columnIndex: number, selectedValues: (string | null)[]}]形式のJSONをzlibで圧縮した集計取引自由カラムのフィルター情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderBusiness(sortType: SortType, limit: number, offset: number, sortTarget?: string, filterItem?: UseFilterItemForOrderBusiness, filterItemObject?: ObjectFilterInfo, orderStatusFilterItem?: OrderStatusFilterItemForOrderBusiness, aggregateFreeColumns?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderBusinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderBusiness(sortType, limit, offset, sortTarget, filterItem, filterItemObject, orderStatusFilterItem, aggregateFreeColumns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GetOrderBusinessApi.getOrderBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GetOrderBusinessApi - factory interface
 * @export
 */
export const GetOrderBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetOrderBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注管理画面表示情報の取得
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItemForOrderBusiness} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {OrderStatusFilterItemForOrderBusiness} [orderStatusFilterItem] 発注ステータスのフィルター (承認依頼、承認済みのみ)
         * @param {string} [aggregateFreeColumns] [{columnIndex: number, selectedValues: (string | null)[]}]形式のJSONをzlibで圧縮した集計取引自由カラムのフィルター情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBusiness(sortType: SortType, limit: number, offset: number, sortTarget?: string, filterItem?: UseFilterItemForOrderBusiness, filterItemObject?: ObjectFilterInfo, orderStatusFilterItem?: OrderStatusFilterItemForOrderBusiness, aggregateFreeColumns?: string, options?: any): AxiosPromise<GetOrderBusinessResponse> {
            return localVarFp.getOrderBusiness(sortType, limit, offset, sortTarget, filterItem, filterItemObject, orderStatusFilterItem, aggregateFreeColumns, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetOrderBusinessApi - object-oriented interface
 * @export
 * @class GetOrderBusinessApi
 * @extends {BaseAPI}
 */
export class GetOrderBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 発注管理画面表示情報の取得
     * @param {SortType} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {string} [sortTarget] ソート対象のカラム名
     * @param {UseFilterItemForOrderBusiness} [filterItem] 列名を指定するフィルター
     * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
     * @param {OrderStatusFilterItemForOrderBusiness} [orderStatusFilterItem] 発注ステータスのフィルター (承認依頼、承認済みのみ)
     * @param {string} [aggregateFreeColumns] [{columnIndex: number, selectedValues: (string | null)[]}]形式のJSONをzlibで圧縮した集計取引自由カラムのフィルター情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetOrderBusinessApi
     */
    public getOrderBusiness(sortType: SortType, limit: number, offset: number, sortTarget?: string, filterItem?: UseFilterItemForOrderBusiness, filterItemObject?: ObjectFilterInfo, orderStatusFilterItem?: OrderStatusFilterItemForOrderBusiness, aggregateFreeColumns?: string, options?: RawAxiosRequestConfig) {
        return GetOrderBusinessApiFp(this.configuration).getOrderBusiness(sortType, limit, offset, sortTarget, filterItem, filterItemObject, orderStatusFilterItem, aggregateFreeColumns, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GetOrderBusinessBelongApi - axios parameter creator
 * @export
 */
export const GetOrderBusinessBelongApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計行IDを参考に子取引を取得する
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {UseFilterItemForOrderBusiness} [filterItem] 列名を指定するフィルター
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBusinessBelong: async (limit: number, offset: number, aggregateBusinessId: string, filterItem?: UseFilterItemForOrderBusiness, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getOrderBusinessBelong', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getOrderBusinessBelong', 'offset', offset)
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('getOrderBusinessBelong', 'aggregateBusinessId', aggregateBusinessId)
            const localVarPath = `/order-business-belong`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (aggregateBusinessId !== undefined) {
                localVarQueryParameter['aggregate_business_id'] = aggregateBusinessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetOrderBusinessBelongApi - functional programming interface
 * @export
 */
export const GetOrderBusinessBelongApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetOrderBusinessBelongApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計行IDを参考に子取引を取得する
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {UseFilterItemForOrderBusiness} [filterItem] 列名を指定するフィルター
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderBusinessBelong(limit: number, offset: number, aggregateBusinessId: string, filterItem?: UseFilterItemForOrderBusiness, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderBusinessBelongResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderBusinessBelong(limit, offset, aggregateBusinessId, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GetOrderBusinessBelongApi.getOrderBusinessBelong']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GetOrderBusinessBelongApi - factory interface
 * @export
 */
export const GetOrderBusinessBelongApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetOrderBusinessBelongApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計行IDを参考に子取引を取得する
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {UseFilterItemForOrderBusiness} [filterItem] 列名を指定するフィルター
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBusinessBelong(limit: number, offset: number, aggregateBusinessId: string, filterItem?: UseFilterItemForOrderBusiness, options?: any): AxiosPromise<GetOrderBusinessBelongResponse> {
            return localVarFp.getOrderBusinessBelong(limit, offset, aggregateBusinessId, filterItem, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetOrderBusinessBelongApi - object-oriented interface
 * @export
 * @class GetOrderBusinessBelongApi
 * @extends {BaseAPI}
 */
export class GetOrderBusinessBelongApi extends BaseAPI {
    /**
     * 
     * @summary 集計行IDを参考に子取引を取得する
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {string} aggregateBusinessId 集計取引ID
     * @param {UseFilterItemForOrderBusiness} [filterItem] 列名を指定するフィルター
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetOrderBusinessBelongApi
     */
    public getOrderBusinessBelong(limit: number, offset: number, aggregateBusinessId: string, filterItem?: UseFilterItemForOrderBusiness, options?: RawAxiosRequestConfig) {
        return GetOrderBusinessBelongApiFp(this.configuration).getOrderBusinessBelong(limit, offset, aggregateBusinessId, filterItem, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注画面で、選択した発注を一括削除するAPI
         * @param {BulkDeleteOrderRequest} bulkDeleteOrderRequest 選択した発注項目の一括削除を行う
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteOrder: async (bulkDeleteOrderRequest: BulkDeleteOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDeleteOrderRequest' is not null or undefined
            assertParamExists('bulkDeleteOrder', 'bulkDeleteOrderRequest', bulkDeleteOrderRequest)
            const localVarPath = `/order/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {BulkPostOrderRequest} bulkPostOrderRequest 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPostOrder: async (bulkPostOrderRequest: BulkPostOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkPostOrderRequest' is not null or undefined
            assertParamExists('bulkPostOrder', 'bulkPostOrderRequest', bulkPostOrderRequest)
            const localVarPath = `/order/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPostOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注テーブルの情報を一括編集するAPI
         * @param {BulkPutOrderRequest} bulkPutOrderRequest 発注テーブルの情報を一括編集するための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPutOrder: async (bulkPutOrderRequest: BulkPutOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkPutOrderRequest' is not null or undefined
            assertParamExists('bulkPutOrder', 'bulkPutOrderRequest', bulkPutOrderRequest)
            const localVarPath = `/order/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPutOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注納期(ETA)を一括で変更する
         * @param {BulkUpdateOrderEtaRequest} bulkUpdateOrderEtaRequest 発注テーブルの情報を一括編集するための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateOrderEta: async (bulkUpdateOrderEtaRequest: BulkUpdateOrderEtaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateOrderEtaRequest' is not null or undefined
            assertParamExists('bulkUpdateOrderEta', 'bulkUpdateOrderEtaRequest', bulkUpdateOrderEtaRequest)
            const localVarPath = `/order/bulk/eta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateOrderEtaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注情報テーブルから情報の取得を行う
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {boolean} isUnexportedOnly 出力が済んでいるかどうか
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] 列名を指定するフィルター
         * @param {string} [orderStatusFilterItem] 発注ステータスのフィルター
         * @param {string} [targetDate] 発注カレンダー向けのクエリパラメータ、取得したい年月を指定する
         * @param {boolean} [isLimitless] 発注カレンダー向けのクエリパラメータ、全件取得するかどうか. Trueの場合LimitとOffsetは無視される
         * @param {string} [aggregateFreeColumns] [{columnIndex: number, selectedValues: (string | null)[]}]形式のJSONをzlibで圧縮した集計取引自由カラムのフィルター情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: async (sortType: SortType, limit: number, offset: number, isUnexportedOnly: boolean, sortTarget?: string, filterItem?: UseFilterItem, orderStatusFilterItem?: string, targetDate?: string, isLimitless?: boolean, aggregateFreeColumns?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getOrder', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getOrder', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getOrder', 'offset', offset)
            // verify required parameter 'isUnexportedOnly' is not null or undefined
            assertParamExists('getOrder', 'isUnexportedOnly', isUnexportedOnly)
            const localVarPath = `/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (isUnexportedOnly !== undefined) {
                localVarQueryParameter['is_unexported_only'] = isUnexportedOnly;
            }

            if (orderStatusFilterItem !== undefined) {
                localVarQueryParameter['orderStatusFilterItem'] = orderStatusFilterItem;
            }

            if (targetDate !== undefined) {
                localVarQueryParameter['target_date'] = (targetDate as any instanceof Date) ?
                    (targetDate as any).toISOString().substring(0,10) :
                    targetDate;
            }

            if (isLimitless !== undefined) {
                localVarQueryParameter['is_limitless'] = isLimitless;
            }

            if (aggregateFreeColumns !== undefined) {
                localVarQueryParameter['aggregateFreeColumns'] = aggregateFreeColumns;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {PostOrderRequestInfo} postOrderRequestInfo 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrder: async (postOrderRequestInfo: PostOrderRequestInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postOrderRequestInfo' is not null or undefined
            assertParamExists('postOrder', 'postOrderRequestInfo', postOrderRequestInfo)
            const localVarPath = `/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOrderRequestInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注画面で、編集モード時に編集するAPI
         * @param {UpdateOrderInfoRequest} updateOrderInfoRequest 発注管理画面で単一の発注情報を更新する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderInfo: async (updateOrderInfoRequest: UpdateOrderInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateOrderInfoRequest' is not null or undefined
            assertParamExists('updateOrderInfo', 'updateOrderInfoRequest', updateOrderInfoRequest)
            const localVarPath = `/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注画面で、選択した発注を一括削除するAPI
         * @param {BulkDeleteOrderRequest} bulkDeleteOrderRequest 選択した発注項目の一括削除を行う
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteOrder(bulkDeleteOrderRequest: BulkDeleteOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteOrder(bulkDeleteOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.bulkDeleteOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {BulkPostOrderRequest} bulkPostOrderRequest 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkPostOrder(bulkPostOrderRequest: BulkPostOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkPostOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkPostOrder(bulkPostOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.bulkPostOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注テーブルの情報を一括編集するAPI
         * @param {BulkPutOrderRequest} bulkPutOrderRequest 発注テーブルの情報を一括編集するための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkPutOrder(bulkPutOrderRequest: BulkPutOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkPutOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkPutOrder(bulkPutOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.bulkPutOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注納期(ETA)を一括で変更する
         * @param {BulkUpdateOrderEtaRequest} bulkUpdateOrderEtaRequest 発注テーブルの情報を一括編集するための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateOrderEta(bulkUpdateOrderEtaRequest: BulkUpdateOrderEtaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateOrderEta(bulkUpdateOrderEtaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.bulkUpdateOrderEta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注情報テーブルから情報の取得を行う
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {boolean} isUnexportedOnly 出力が済んでいるかどうか
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] 列名を指定するフィルター
         * @param {string} [orderStatusFilterItem] 発注ステータスのフィルター
         * @param {string} [targetDate] 発注カレンダー向けのクエリパラメータ、取得したい年月を指定する
         * @param {boolean} [isLimitless] 発注カレンダー向けのクエリパラメータ、全件取得するかどうか. Trueの場合LimitとOffsetは無視される
         * @param {string} [aggregateFreeColumns] [{columnIndex: number, selectedValues: (string | null)[]}]形式のJSONをzlibで圧縮した集計取引自由カラムのフィルター情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrder(sortType: SortType, limit: number, offset: number, isUnexportedOnly: boolean, sortTarget?: string, filterItem?: UseFilterItem, orderStatusFilterItem?: string, targetDate?: string, isLimitless?: boolean, aggregateFreeColumns?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrder(sortType, limit, offset, isUnexportedOnly, sortTarget, filterItem, orderStatusFilterItem, targetDate, isLimitless, aggregateFreeColumns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.getOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {PostOrderRequestInfo} postOrderRequestInfo 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrder(postOrderRequestInfo: PostOrderRequestInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrder(postOrderRequestInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.postOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注画面で、編集モード時に編集するAPI
         * @param {UpdateOrderInfoRequest} updateOrderInfoRequest 発注管理画面で単一の発注情報を更新する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderInfo(updateOrderInfoRequest: UpdateOrderInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderInfo(updateOrderInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.updateOrderInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注画面で、選択した発注を一括削除するAPI
         * @param {BulkDeleteOrderRequest} bulkDeleteOrderRequest 選択した発注項目の一括削除を行う
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteOrder(bulkDeleteOrderRequest: BulkDeleteOrderRequest, options?: any): AxiosPromise<UpdateOrderResponse> {
            return localVarFp.bulkDeleteOrder(bulkDeleteOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {BulkPostOrderRequest} bulkPostOrderRequest 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPostOrder(bulkPostOrderRequest: BulkPostOrderRequest, options?: any): AxiosPromise<BulkPostOrderResponse> {
            return localVarFp.bulkPostOrder(bulkPostOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注テーブルの情報を一括編集するAPI
         * @param {BulkPutOrderRequest} bulkPutOrderRequest 発注テーブルの情報を一括編集するための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPutOrder(bulkPutOrderRequest: BulkPutOrderRequest, options?: any): AxiosPromise<BulkPutOrderResponse> {
            return localVarFp.bulkPutOrder(bulkPutOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注納期(ETA)を一括で変更する
         * @param {BulkUpdateOrderEtaRequest} bulkUpdateOrderEtaRequest 発注テーブルの情報を一括編集するための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateOrderEta(bulkUpdateOrderEtaRequest: BulkUpdateOrderEtaRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.bulkUpdateOrderEta(bulkUpdateOrderEtaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注情報テーブルから情報の取得を行う
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {boolean} isUnexportedOnly 出力が済んでいるかどうか
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] 列名を指定するフィルター
         * @param {string} [orderStatusFilterItem] 発注ステータスのフィルター
         * @param {string} [targetDate] 発注カレンダー向けのクエリパラメータ、取得したい年月を指定する
         * @param {boolean} [isLimitless] 発注カレンダー向けのクエリパラメータ、全件取得するかどうか. Trueの場合LimitとOffsetは無視される
         * @param {string} [aggregateFreeColumns] [{columnIndex: number, selectedValues: (string | null)[]}]形式のJSONをzlibで圧縮した集計取引自由カラムのフィルター情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(sortType: SortType, limit: number, offset: number, isUnexportedOnly: boolean, sortTarget?: string, filterItem?: UseFilterItem, orderStatusFilterItem?: string, targetDate?: string, isLimitless?: boolean, aggregateFreeColumns?: string, options?: any): AxiosPromise<GetOrderResponse> {
            return localVarFp.getOrder(sortType, limit, offset, isUnexportedOnly, sortTarget, filterItem, orderStatusFilterItem, targetDate, isLimitless, aggregateFreeColumns, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {PostOrderRequestInfo} postOrderRequestInfo 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrder(postOrderRequestInfo: PostOrderRequestInfo, options?: any): AxiosPromise<PostOrderResponse> {
            return localVarFp.postOrder(postOrderRequestInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注画面で、編集モード時に編集するAPI
         * @param {UpdateOrderInfoRequest} updateOrderInfoRequest 発注管理画面で単一の発注情報を更新する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderInfo(updateOrderInfoRequest: UpdateOrderInfoRequest, options?: any): AxiosPromise<UpdateOrderResponse> {
            return localVarFp.updateOrderInfo(updateOrderInfoRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
    /**
     * 
     * @summary 発注画面で、選択した発注を一括削除するAPI
     * @param {BulkDeleteOrderRequest} bulkDeleteOrderRequest 選択した発注項目の一括削除を行う
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public bulkDeleteOrder(bulkDeleteOrderRequest: BulkDeleteOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).bulkDeleteOrder(bulkDeleteOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注テーブルに情報の登録を行う
     * @param {BulkPostOrderRequest} bulkPostOrderRequest 発注テーブルに登録するために必要な情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public bulkPostOrder(bulkPostOrderRequest: BulkPostOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).bulkPostOrder(bulkPostOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注テーブルの情報を一括編集するAPI
     * @param {BulkPutOrderRequest} bulkPutOrderRequest 発注テーブルの情報を一括編集するための情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public bulkPutOrder(bulkPutOrderRequest: BulkPutOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).bulkPutOrder(bulkPutOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注納期(ETA)を一括で変更する
     * @param {BulkUpdateOrderEtaRequest} bulkUpdateOrderEtaRequest 発注テーブルの情報を一括編集するための情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public bulkUpdateOrderEta(bulkUpdateOrderEtaRequest: BulkUpdateOrderEtaRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).bulkUpdateOrderEta(bulkUpdateOrderEtaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注情報テーブルから情報の取得を行う
     * @param {SortType} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {boolean} isUnexportedOnly 出力が済んでいるかどうか
     * @param {string} [sortTarget] ソート対象のカラム名
     * @param {UseFilterItem} [filterItem] 列名を指定するフィルター
     * @param {string} [orderStatusFilterItem] 発注ステータスのフィルター
     * @param {string} [targetDate] 発注カレンダー向けのクエリパラメータ、取得したい年月を指定する
     * @param {boolean} [isLimitless] 発注カレンダー向けのクエリパラメータ、全件取得するかどうか. Trueの場合LimitとOffsetは無視される
     * @param {string} [aggregateFreeColumns] [{columnIndex: number, selectedValues: (string | null)[]}]形式のJSONをzlibで圧縮した集計取引自由カラムのフィルター情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getOrder(sortType: SortType, limit: number, offset: number, isUnexportedOnly: boolean, sortTarget?: string, filterItem?: UseFilterItem, orderStatusFilterItem?: string, targetDate?: string, isLimitless?: boolean, aggregateFreeColumns?: string, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).getOrder(sortType, limit, offset, isUnexportedOnly, sortTarget, filterItem, orderStatusFilterItem, targetDate, isLimitless, aggregateFreeColumns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注テーブルに情報の登録を行う
     * @param {PostOrderRequestInfo} postOrderRequestInfo 発注テーブルに登録するために必要な情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public postOrder(postOrderRequestInfo: PostOrderRequestInfo, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).postOrder(postOrderRequestInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注画面で、編集モード時に編集するAPI
     * @param {UpdateOrderInfoRequest} updateOrderInfoRequest 発注管理画面で単一の発注情報を更新する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public updateOrderInfo(updateOrderInfoRequest: UpdateOrderInfoRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).updateOrderInfo(updateOrderInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderAmountApi - axios parameter creator
 * @export
 */
export const OrderAmountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注数量一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAmountGet: async (keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-amount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderAmountApi - functional programming interface
 * @export
 */
export const OrderAmountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderAmountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注数量一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderAmountGet(keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderAmountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderAmountGet(keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderAmountApi.orderAmountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderAmountApi - factory interface
 * @export
 */
export const OrderAmountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderAmountApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注数量一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAmountGet(keyWord?: string, options?: any): AxiosPromise<OrderAmountResponse> {
            return localVarFp.orderAmountGet(keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderAmountApi - object-oriented interface
 * @export
 * @class OrderAmountApi
 * @extends {BaseAPI}
 */
export class OrderAmountApi extends BaseAPI {
    /**
     * 
     * @summary 発注数量一覧を取得する
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAmountApi
     */
    public orderAmountGet(keyWord?: string, options?: RawAxiosRequestConfig) {
        return OrderAmountApiFp(this.configuration).orderAmountGet(keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderBusinessApi - axios parameter creator
 * @export
 */
export const OrderBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注取引の登録更新処理
         * @param {BulkRegisterOrderBusinessRequest} bulkRegisterOrderBusinessRequest 発注取引の更新処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRegisterOrderBusiness: async (bulkRegisterOrderBusinessRequest: BulkRegisterOrderBusinessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkRegisterOrderBusinessRequest' is not null or undefined
            assertParamExists('bulkRegisterOrderBusiness', 'bulkRegisterOrderBusinessRequest', bulkRegisterOrderBusinessRequest)
            const localVarPath = `/order-business/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkRegisterOrderBusinessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderBusinessApi - functional programming interface
 * @export
 */
export const OrderBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注取引の登録更新処理
         * @param {BulkRegisterOrderBusinessRequest} bulkRegisterOrderBusinessRequest 発注取引の更新処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkRegisterOrderBusiness(bulkRegisterOrderBusinessRequest: BulkRegisterOrderBusinessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkRegisterOrderBusinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkRegisterOrderBusiness(bulkRegisterOrderBusinessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderBusinessApi.bulkRegisterOrderBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderBusinessApi - factory interface
 * @export
 */
export const OrderBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注取引の登録更新処理
         * @param {BulkRegisterOrderBusinessRequest} bulkRegisterOrderBusinessRequest 発注取引の更新処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRegisterOrderBusiness(bulkRegisterOrderBusinessRequest: BulkRegisterOrderBusinessRequest, options?: any): AxiosPromise<BulkRegisterOrderBusinessResponse> {
            return localVarFp.bulkRegisterOrderBusiness(bulkRegisterOrderBusinessRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderBusinessApi - object-oriented interface
 * @export
 * @class OrderBusinessApi
 * @extends {BaseAPI}
 */
export class OrderBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 発注取引の登録更新処理
     * @param {BulkRegisterOrderBusinessRequest} bulkRegisterOrderBusinessRequest 発注取引の更新処理
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderBusinessApi
     */
    public bulkRegisterOrderBusiness(bulkRegisterOrderBusinessRequest: BulkRegisterOrderBusinessRequest, options?: RawAxiosRequestConfig) {
        return OrderBusinessApiFp(this.configuration).bulkRegisterOrderBusiness(bulkRegisterOrderBusinessRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderDateApi - axios parameter creator
 * @export
 */
export const OrderDateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注日一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDateGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderDateApi - functional programming interface
 * @export
 */
export const OrderDateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderDateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注日一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderDateGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderDateGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderDateApi.orderDateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderDateApi - factory interface
 * @export
 */
export const OrderDateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderDateApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注日一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDateGet(options?: any): AxiosPromise<OrderDateResponse> {
            return localVarFp.orderDateGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderDateApi - object-oriented interface
 * @export
 * @class OrderDateApi
 * @extends {BaseAPI}
 */
export class OrderDateApi extends BaseAPI {
    /**
     * 
     * @summary 発注日一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDateApi
     */
    public orderDateGet(options?: RawAxiosRequestConfig) {
        return OrderDateApiFp(this.configuration).orderDateGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderDeliveryDateApi - axios parameter creator
 * @export
 */
export const OrderDeliveryDateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 納期一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDeliveryDateGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-delivery-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderDeliveryDateApi - functional programming interface
 * @export
 */
export const OrderDeliveryDateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderDeliveryDateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 納期一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderDeliveryDateGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDeliveryDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderDeliveryDateGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderDeliveryDateApi.orderDeliveryDateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderDeliveryDateApi - factory interface
 * @export
 */
export const OrderDeliveryDateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderDeliveryDateApiFp(configuration)
    return {
        /**
         * 
         * @summary 納期一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDeliveryDateGet(options?: any): AxiosPromise<OrderDeliveryDateResponse> {
            return localVarFp.orderDeliveryDateGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderDeliveryDateApi - object-oriented interface
 * @export
 * @class OrderDeliveryDateApi
 * @extends {BaseAPI}
 */
export class OrderDeliveryDateApi extends BaseAPI {
    /**
     * 
     * @summary 納期一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDeliveryDateApi
     */
    public orderDeliveryDateGet(options?: RawAxiosRequestConfig) {
        return OrderDeliveryDateApiFp(this.configuration).orderDeliveryDateGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderDesiredDeliveryDateApi - axios parameter creator
 * @export
 */
export const OrderDesiredDeliveryDateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 希望納期一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDesiredDeliveryDateGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-desired-delivery-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderDesiredDeliveryDateApi - functional programming interface
 * @export
 */
export const OrderDesiredDeliveryDateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderDesiredDeliveryDateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 希望納期一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderDesiredDeliveryDateGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDesiredDeliveryDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderDesiredDeliveryDateGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderDesiredDeliveryDateApi.orderDesiredDeliveryDateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderDesiredDeliveryDateApi - factory interface
 * @export
 */
export const OrderDesiredDeliveryDateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderDesiredDeliveryDateApiFp(configuration)
    return {
        /**
         * 
         * @summary 希望納期一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDesiredDeliveryDateGet(options?: any): AxiosPromise<OrderDesiredDeliveryDateResponse> {
            return localVarFp.orderDesiredDeliveryDateGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderDesiredDeliveryDateApi - object-oriented interface
 * @export
 * @class OrderDesiredDeliveryDateApi
 * @extends {BaseAPI}
 */
export class OrderDesiredDeliveryDateApi extends BaseAPI {
    /**
     * 
     * @summary 希望納期一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDesiredDeliveryDateApi
     */
    public orderDesiredDeliveryDateGet(options?: RawAxiosRequestConfig) {
        return OrderDesiredDeliveryDateApiFp(this.configuration).orderDesiredDeliveryDateGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderIdsApi - axios parameter creator
 * @export
 */
export const OrderIdsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注ID一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderIdGet: async (keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderIdsApi - functional programming interface
 * @export
 */
export const OrderIdsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderIdsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注ID一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderIdGet(keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderIdsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderIdGet(keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderIdsApi.orderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderIdsApi - factory interface
 * @export
 */
export const OrderIdsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderIdsApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注ID一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderIdGet(keyWord?: string, options?: any): AxiosPromise<OrderIdsResponse> {
            return localVarFp.orderIdGet(keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderIdsApi - object-oriented interface
 * @export
 * @class OrderIdsApi
 * @extends {BaseAPI}
 */
export class OrderIdsApi extends BaseAPI {
    /**
     * 
     * @summary 発注ID一覧を取得する
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderIdsApi
     */
    public orderIdGet(keyWord?: string, options?: RawAxiosRequestConfig) {
        return OrderIdsApiFp(this.configuration).orderIdGet(keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderMemoApi - axios parameter creator
 * @export
 */
export const OrderMemoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注メモのクリア
         * @param {string} orderId 発注ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOrderMemo: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('clearOrderMemo', 'orderId', orderId)
            const localVarPath = `/order-memo/clear/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注メモの更新
         * @param {string} orderId 発注ID
         * @param {UpdateOrderMemoRequest} updateOrderMemoRequest 発注メモの更新内容
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderMemo: async (orderId: string, updateOrderMemoRequest: UpdateOrderMemoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateOrderMemo', 'orderId', orderId)
            // verify required parameter 'updateOrderMemoRequest' is not null or undefined
            assertParamExists('updateOrderMemo', 'updateOrderMemoRequest', updateOrderMemoRequest)
            const localVarPath = `/order-memo/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderMemoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderMemoApi - functional programming interface
 * @export
 */
export const OrderMemoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderMemoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注メモのクリア
         * @param {string} orderId 発注ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearOrderMemo(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearOrderMemo(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderMemoApi.clearOrderMemo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注メモの更新
         * @param {string} orderId 発注ID
         * @param {UpdateOrderMemoRequest} updateOrderMemoRequest 発注メモの更新内容
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderMemo(orderId: string, updateOrderMemoRequest: UpdateOrderMemoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderMemo(orderId, updateOrderMemoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderMemoApi.updateOrderMemo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderMemoApi - factory interface
 * @export
 */
export const OrderMemoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderMemoApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注メモのクリア
         * @param {string} orderId 発注ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOrderMemo(orderId: string, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.clearOrderMemo(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注メモの更新
         * @param {string} orderId 発注ID
         * @param {UpdateOrderMemoRequest} updateOrderMemoRequest 発注メモの更新内容
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderMemo(orderId: string, updateOrderMemoRequest: UpdateOrderMemoRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.updateOrderMemo(orderId, updateOrderMemoRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderMemoApi - object-oriented interface
 * @export
 * @class OrderMemoApi
 * @extends {BaseAPI}
 */
export class OrderMemoApi extends BaseAPI {
    /**
     * 
     * @summary 発注メモのクリア
     * @param {string} orderId 発注ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderMemoApi
     */
    public clearOrderMemo(orderId: string, options?: RawAxiosRequestConfig) {
        return OrderMemoApiFp(this.configuration).clearOrderMemo(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注メモの更新
     * @param {string} orderId 発注ID
     * @param {UpdateOrderMemoRequest} updateOrderMemoRequest 発注メモの更新内容
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderMemoApi
     */
    public updateOrderMemo(orderId: string, updateOrderMemoRequest: UpdateOrderMemoRequest, options?: RawAxiosRequestConfig) {
        return OrderMemoApiFp(this.configuration).updateOrderMemo(orderId, updateOrderMemoRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderNumbersApi - axios parameter creator
 * @export
 */
export const OrderNumbersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注番号一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderNumberGet: async (keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderNumbersApi - functional programming interface
 * @export
 */
export const OrderNumbersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderNumbersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注番号一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderNumberGet(keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderNumbersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderNumberGet(keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderNumbersApi.orderNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderNumbersApi - factory interface
 * @export
 */
export const OrderNumbersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderNumbersApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注番号一覧を取得する
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderNumberGet(keyWord?: string, options?: any): AxiosPromise<OrderNumbersResponse> {
            return localVarFp.orderNumberGet(keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderNumbersApi - object-oriented interface
 * @export
 * @class OrderNumbersApi
 * @extends {BaseAPI}
 */
export class OrderNumbersApi extends BaseAPI {
    /**
     * 
     * @summary 発注番号一覧を取得する
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderNumbersApi
     */
    public orderNumberGet(keyWord?: string, options?: RawAxiosRequestConfig) {
        return OrderNumbersApiFp(this.configuration).orderNumberGet(keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderTemplateApi - axios parameter creator
 * @export
 */
export const OrderTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注テンプレートを登録する
         * @param {OrderTemplateUpsertRequest} orderTemplateUpsertRequest 発注テンプレートの登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderTemplate: async (orderTemplateUpsertRequest: OrderTemplateUpsertRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderTemplateUpsertRequest' is not null or undefined
            assertParamExists('createOrderTemplate', 'orderTemplateUpsertRequest', orderTemplateUpsertRequest)
            const localVarPath = `/order-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderTemplateUpsertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注テンプレートファイルのアップロード用URLを発行する
         * @param {OrderTemplatePresignedUploadRequest} orderTemplatePresignedUploadRequest Presigned URL発行に必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderTemplateUploadUrl: async (orderTemplatePresignedUploadRequest: OrderTemplatePresignedUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderTemplatePresignedUploadRequest' is not null or undefined
            assertParamExists('createOrderTemplateUploadUrl', 'orderTemplatePresignedUploadRequest', orderTemplatePresignedUploadRequest)
            const localVarPath = `/order-templates/presigned-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderTemplatePresignedUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注テンプレートを削除する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteOrderTemplate', 'templateId', templateId)
            const localVarPath = `/order-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定した発注テンプレートの詳細を取得する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getOrderTemplate', 'templateId', templateId)
            const localVarPath = `/order-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注テンプレートファイルのダウンロード用URLを取得する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateDownloadUrl: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getOrderTemplateDownloadUrl', 'templateId', templateId)
            const localVarPath = `/order-templates/{template_id}/presigned-download`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注テンプレート一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注テンプレートを更新する
         * @param {string} templateId テンプレートID
         * @param {OrderTemplateUpsertRequest} orderTemplateUpsertRequest 発注テンプレートの更新情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderTemplate: async (templateId: string, orderTemplateUpsertRequest: OrderTemplateUpsertRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateOrderTemplate', 'templateId', templateId)
            // verify required parameter 'orderTemplateUpsertRequest' is not null or undefined
            assertParamExists('updateOrderTemplate', 'orderTemplateUpsertRequest', orderTemplateUpsertRequest)
            const localVarPath = `/order-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderTemplateUpsertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderTemplateApi - functional programming interface
 * @export
 */
export const OrderTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注テンプレートを登録する
         * @param {OrderTemplateUpsertRequest} orderTemplateUpsertRequest 発注テンプレートの登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderTemplate(orderTemplateUpsertRequest: OrderTemplateUpsertRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOrderTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderTemplate(orderTemplateUpsertRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTemplateApi.createOrderTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注テンプレートファイルのアップロード用URLを発行する
         * @param {OrderTemplatePresignedUploadRequest} orderTemplatePresignedUploadRequest Presigned URL発行に必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderTemplateUploadUrl(orderTemplatePresignedUploadRequest: OrderTemplatePresignedUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTemplatePresignedUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderTemplateUploadUrl(orderTemplatePresignedUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTemplateApi.createOrderTemplateUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注テンプレートを削除する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrderTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrderTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTemplateApi.deleteOrderTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定した発注テンプレートの詳細を取得する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTemplateApi.getOrderTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注テンプレートファイルのダウンロード用URLを取得する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderTemplateDownloadUrl(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTemplatePresignedDownloadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderTemplateDownloadUrl(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTemplateApi.getOrderTemplateDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注テンプレート一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderTemplateList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderTemplateList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTemplateApi.getOrderTemplateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注テンプレートを更新する
         * @param {string} templateId テンプレートID
         * @param {OrderTemplateUpsertRequest} orderTemplateUpsertRequest 発注テンプレートの更新情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderTemplate(templateId: string, orderTemplateUpsertRequest: OrderTemplateUpsertRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutOrderTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderTemplate(templateId, orderTemplateUpsertRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTemplateApi.updateOrderTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderTemplateApi - factory interface
 * @export
 */
export const OrderTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注テンプレートを登録する
         * @param {OrderTemplateUpsertRequest} orderTemplateUpsertRequest 発注テンプレートの登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderTemplate(orderTemplateUpsertRequest: OrderTemplateUpsertRequest, options?: any): AxiosPromise<PostOrderTemplateResponse> {
            return localVarFp.createOrderTemplate(orderTemplateUpsertRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注テンプレートファイルのアップロード用URLを発行する
         * @param {OrderTemplatePresignedUploadRequest} orderTemplatePresignedUploadRequest Presigned URL発行に必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderTemplateUploadUrl(orderTemplatePresignedUploadRequest: OrderTemplatePresignedUploadRequest, options?: any): AxiosPromise<OrderTemplatePresignedUploadResponse> {
            return localVarFp.createOrderTemplateUploadUrl(orderTemplatePresignedUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注テンプレートを削除する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderTemplate(templateId: string, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.deleteOrderTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定した発注テンプレートの詳細を取得する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplate(templateId: string, options?: any): AxiosPromise<GetOrderTemplateResponse> {
            return localVarFp.getOrderTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注テンプレートファイルのダウンロード用URLを取得する
         * @param {string} templateId テンプレートID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateDownloadUrl(templateId: string, options?: any): AxiosPromise<OrderTemplatePresignedDownloadResponse> {
            return localVarFp.getOrderTemplateDownloadUrl(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注テンプレート一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateList(options?: any): AxiosPromise<GetOrderTemplateListResponse> {
            return localVarFp.getOrderTemplateList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注テンプレートを更新する
         * @param {string} templateId テンプレートID
         * @param {OrderTemplateUpsertRequest} orderTemplateUpsertRequest 発注テンプレートの更新情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderTemplate(templateId: string, orderTemplateUpsertRequest: OrderTemplateUpsertRequest, options?: any): AxiosPromise<PutOrderTemplateResponse> {
            return localVarFp.updateOrderTemplate(templateId, orderTemplateUpsertRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderTemplateApi - object-oriented interface
 * @export
 * @class OrderTemplateApi
 * @extends {BaseAPI}
 */
export class OrderTemplateApi extends BaseAPI {
    /**
     * 
     * @summary 発注テンプレートを登録する
     * @param {OrderTemplateUpsertRequest} orderTemplateUpsertRequest 発注テンプレートの登録情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplateApi
     */
    public createOrderTemplate(orderTemplateUpsertRequest: OrderTemplateUpsertRequest, options?: RawAxiosRequestConfig) {
        return OrderTemplateApiFp(this.configuration).createOrderTemplate(orderTemplateUpsertRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注テンプレートファイルのアップロード用URLを発行する
     * @param {OrderTemplatePresignedUploadRequest} orderTemplatePresignedUploadRequest Presigned URL発行に必要な情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplateApi
     */
    public createOrderTemplateUploadUrl(orderTemplatePresignedUploadRequest: OrderTemplatePresignedUploadRequest, options?: RawAxiosRequestConfig) {
        return OrderTemplateApiFp(this.configuration).createOrderTemplateUploadUrl(orderTemplatePresignedUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注テンプレートを削除する
     * @param {string} templateId テンプレートID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplateApi
     */
    public deleteOrderTemplate(templateId: string, options?: RawAxiosRequestConfig) {
        return OrderTemplateApiFp(this.configuration).deleteOrderTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定した発注テンプレートの詳細を取得する
     * @param {string} templateId テンプレートID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplateApi
     */
    public getOrderTemplate(templateId: string, options?: RawAxiosRequestConfig) {
        return OrderTemplateApiFp(this.configuration).getOrderTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注テンプレートファイルのダウンロード用URLを取得する
     * @param {string} templateId テンプレートID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplateApi
     */
    public getOrderTemplateDownloadUrl(templateId: string, options?: RawAxiosRequestConfig) {
        return OrderTemplateApiFp(this.configuration).getOrderTemplateDownloadUrl(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注テンプレート一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplateApi
     */
    public getOrderTemplateList(options?: RawAxiosRequestConfig) {
        return OrderTemplateApiFp(this.configuration).getOrderTemplateList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注テンプレートを更新する
     * @param {string} templateId テンプレートID
     * @param {OrderTemplateUpsertRequest} orderTemplateUpsertRequest 発注テンプレートの更新情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplateApi
     */
    public updateOrderTemplate(templateId: string, orderTemplateUpsertRequest: OrderTemplateUpsertRequest, options?: RawAxiosRequestConfig) {
        return OrderTemplateApiFp(this.configuration).updateOrderTemplate(templateId, orderTemplateUpsertRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OutputOrderApi - axios parameter creator
 * @export
 */
export const OutputOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary テンプレート定義に基づき発注帳票を生成する
         * @param {OutputOrderRequest} outputOrderRequest 出力処理に必要な発注IDとテンプレート情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputOrder: async (outputOrderRequest: OutputOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outputOrderRequest' is not null or undefined
            assertParamExists('outputOrder', 'outputOrderRequest', outputOrderRequest)
            const localVarPath = `/output-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outputOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutputOrderApi - functional programming interface
 * @export
 */
export const OutputOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutputOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary テンプレート定義に基づき発注帳票を生成する
         * @param {OutputOrderRequest} outputOrderRequest 出力処理に必要な発注IDとテンプレート情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async outputOrder(outputOrderRequest: OutputOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.outputOrder(outputOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutputOrderApi.outputOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OutputOrderApi - factory interface
 * @export
 */
export const OutputOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutputOrderApiFp(configuration)
    return {
        /**
         * 
         * @summary テンプレート定義に基づき発注帳票を生成する
         * @param {OutputOrderRequest} outputOrderRequest 出力処理に必要な発注IDとテンプレート情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputOrder(outputOrderRequest: OutputOrderRequest, options?: any): AxiosPromise<OutputOrderResponse> {
            return localVarFp.outputOrder(outputOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OutputOrderApi - object-oriented interface
 * @export
 * @class OutputOrderApi
 * @extends {BaseAPI}
 */
export class OutputOrderApi extends BaseAPI {
    /**
     * 
     * @summary テンプレート定義に基づき発注帳票を生成する
     * @param {OutputOrderRequest} outputOrderRequest 出力処理に必要な発注IDとテンプレート情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutputOrderApi
     */
    public outputOrder(outputOrderRequest: OutputOrderRequest, options?: RawAxiosRequestConfig) {
        return OutputOrderApiFp(this.configuration).outputOrder(outputOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UpdateOrderStatusApi - axios parameter creator
 * @export
 */
export const UpdateOrderStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注画面の発注ステータス一括更新
         * @param {UpdateOrderStatusRequest} updateOrderStatusRequest 発注ステータスの一括更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderStatus: async (updateOrderStatusRequest: UpdateOrderStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateOrderStatusRequest' is not null or undefined
            assertParamExists('updateOrderStatus', 'updateOrderStatusRequest', updateOrderStatusRequest)
            const localVarPath = `/order-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdateOrderStatusApi - functional programming interface
 * @export
 */
export const UpdateOrderStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdateOrderStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注画面の発注ステータス一括更新
         * @param {UpdateOrderStatusRequest} updateOrderStatusRequest 発注ステータスの一括更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderStatus(updateOrderStatusRequest: UpdateOrderStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderStatus(updateOrderStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UpdateOrderStatusApi.updateOrderStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UpdateOrderStatusApi - factory interface
 * @export
 */
export const UpdateOrderStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdateOrderStatusApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注画面の発注ステータス一括更新
         * @param {UpdateOrderStatusRequest} updateOrderStatusRequest 発注ステータスの一括更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderStatus(updateOrderStatusRequest: UpdateOrderStatusRequest, options?: any): AxiosPromise<UpdateOrderResponse> {
            return localVarFp.updateOrderStatus(updateOrderStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdateOrderStatusApi - object-oriented interface
 * @export
 * @class UpdateOrderStatusApi
 * @extends {BaseAPI}
 */
export class UpdateOrderStatusApi extends BaseAPI {
    /**
     * 
     * @summary 発注画面の発注ステータス一括更新
     * @param {UpdateOrderStatusRequest} updateOrderStatusRequest 発注ステータスの一括更新
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateOrderStatusApi
     */
    public updateOrderStatus(updateOrderStatusRequest: UpdateOrderStatusRequest, options?: RawAxiosRequestConfig) {
        return UpdateOrderStatusApiFp(this.configuration).updateOrderStatus(updateOrderStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UpdateOutputFlagApi - axios parameter creator
 * @export
 */
export const UpdateOutputFlagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注/未発注フラグを更新する
         * @param {UpdateOutputFlagRequest} updateOutputFlagRequest 発注済み、または未出力に更新する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutputFlag: async (updateOutputFlagRequest: UpdateOutputFlagRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateOutputFlagRequest' is not null or undefined
            assertParamExists('updateOutputFlag', 'updateOutputFlagRequest', updateOutputFlagRequest)
            const localVarPath = `/export-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOutputFlagRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdateOutputFlagApi - functional programming interface
 * @export
 */
export const UpdateOutputFlagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdateOutputFlagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注/未発注フラグを更新する
         * @param {UpdateOutputFlagRequest} updateOutputFlagRequest 発注済み、または未出力に更新する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOutputFlag(updateOutputFlagRequest: UpdateOutputFlagRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOutputFlag(updateOutputFlagRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UpdateOutputFlagApi.updateOutputFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UpdateOutputFlagApi - factory interface
 * @export
 */
export const UpdateOutputFlagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdateOutputFlagApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注/未発注フラグを更新する
         * @param {UpdateOutputFlagRequest} updateOutputFlagRequest 発注済み、または未出力に更新する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutputFlag(updateOutputFlagRequest: UpdateOutputFlagRequest, options?: any): AxiosPromise<UpdateOrderResponse> {
            return localVarFp.updateOutputFlag(updateOutputFlagRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdateOutputFlagApi - object-oriented interface
 * @export
 * @class UpdateOutputFlagApi
 * @extends {BaseAPI}
 */
export class UpdateOutputFlagApi extends BaseAPI {
    /**
     * 
     * @summary 発注/未発注フラグを更新する
     * @param {UpdateOutputFlagRequest} updateOutputFlagRequest 発注済み、または未出力に更新する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateOutputFlagApi
     */
    public updateOutputFlag(updateOutputFlagRequest: UpdateOutputFlagRequest, options?: RawAxiosRequestConfig) {
        return UpdateOutputFlagApiFp(this.configuration).updateOutputFlag(updateOutputFlagRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UpsertOrderAndSingleSimulationApi - axios parameter creator
 * @export
 */
export const UpsertOrderAndSingleSimulationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {UpsertAndSingleSimulationOrderRequestInfo} upsertAndSingleSimulationOrderRequestInfo 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertAndSingleSimulationOrderSingleSimulation: async (upsertAndSingleSimulationOrderRequestInfo: UpsertAndSingleSimulationOrderRequestInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertAndSingleSimulationOrderRequestInfo' is not null or undefined
            assertParamExists('upsertAndSingleSimulationOrderSingleSimulation', 'upsertAndSingleSimulationOrderRequestInfo', upsertAndSingleSimulationOrderRequestInfo)
            const localVarPath = `/order/single-simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertAndSingleSimulationOrderRequestInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpsertOrderAndSingleSimulationApi - functional programming interface
 * @export
 */
export const UpsertOrderAndSingleSimulationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpsertOrderAndSingleSimulationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {UpsertAndSingleSimulationOrderRequestInfo} upsertAndSingleSimulationOrderRequestInfo 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertAndSingleSimulationOrderSingleSimulation(upsertAndSingleSimulationOrderRequestInfo: UpsertAndSingleSimulationOrderRequestInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertAndSingleSimulationOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertAndSingleSimulationOrderSingleSimulation(upsertAndSingleSimulationOrderRequestInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UpsertOrderAndSingleSimulationApi.upsertAndSingleSimulationOrderSingleSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UpsertOrderAndSingleSimulationApi - factory interface
 * @export
 */
export const UpsertOrderAndSingleSimulationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpsertOrderAndSingleSimulationApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注テーブルに情報の登録を行う
         * @param {UpsertAndSingleSimulationOrderRequestInfo} upsertAndSingleSimulationOrderRequestInfo 発注テーブルに登録するために必要な情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertAndSingleSimulationOrderSingleSimulation(upsertAndSingleSimulationOrderRequestInfo: UpsertAndSingleSimulationOrderRequestInfo, options?: any): AxiosPromise<UpsertAndSingleSimulationOrderResponse> {
            return localVarFp.upsertAndSingleSimulationOrderSingleSimulation(upsertAndSingleSimulationOrderRequestInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpsertOrderAndSingleSimulationApi - object-oriented interface
 * @export
 * @class UpsertOrderAndSingleSimulationApi
 * @extends {BaseAPI}
 */
export class UpsertOrderAndSingleSimulationApi extends BaseAPI {
    /**
     * 
     * @summary 発注テーブルに情報の登録を行う
     * @param {UpsertAndSingleSimulationOrderRequestInfo} upsertAndSingleSimulationOrderRequestInfo 発注テーブルに登録するために必要な情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpsertOrderAndSingleSimulationApi
     */
    public upsertAndSingleSimulationOrderSingleSimulation(upsertAndSingleSimulationOrderRequestInfo: UpsertAndSingleSimulationOrderRequestInfo, options?: RawAxiosRequestConfig) {
        return UpsertOrderAndSingleSimulationApiFp(this.configuration).upsertAndSingleSimulationOrderSingleSimulation(upsertAndSingleSimulationOrderRequestInfo, options).then((request) => request(this.axios, this.basePath));
    }
}



